/* ==========================================================================
   PROPER JACK — Quiz V2 / diagnostic.js  (v2.2 — GA4 tracking)
   12 telas: 1.Dores, 2.Principal Dor (cond.), 3.Nível Acne (cond.), 4.Nome,
   5.Antes/Depois*, 6.Tom de pele, 7.Tipo de pele, 8.Tempo de rotina, 9.Idade,
   10.Frequência, 11.Forbes*, 12.Contato.
   * = interstitials (sem validação, CTA "Continuar")
   cond. step 2: aparece só se dores.length >= 2.
   cond. step 3: aparece só se principalDor === 'acne'.
   ========================================================================== */

(function () {
  'use strict';

  var STATE_KEY = 'proper_diagnostic_state';
  var STATE_TTL_MS = 31 * 24 * 60 * 60 * 1000; // 31 dias
  var STEP_COUNT = 12;
  var INTERSTITIAL_STEPS = [5, 11];

  var TIPO_PELE_LABELS = {
    oleosa: 'Oleosa',
    seca: 'Seca',
    sensivel: 'Sensível',
    mista: 'Mista',
    normal: 'Normal',
    naosei: 'Em análise'
  };

  var DOR_LABELS = {
    acne: 'Acne',
    oleosidade: 'Oleosidade',
    saude: 'Saúde da pele',
    poros: 'Poros dilatados',
    manchas: 'Manchas',
    vermelhidao: 'Vermelhidão',
    sinais: 'Sinais de idade',
    olheiras: 'Olheiras'
  };

  /* ----- State --------------------------------------------------------- */

  function makeInitialState() {
    return {
      step: 1,
      answers: {
        dores: [],
        principalDor: '',
        acneNivel: '',
        frequencia: '',
        tomPele: '',
        tipoPele: '',
        tempoRotina: '',
        idade: '',
        nome: '',
        email: '',
        whatsapp: ''
      },
      startedAt: new Date().toISOString(),
      updatedAt: null,
      completedAt: null
    };
  }

  function loadState() {
    try {
      var raw = localStorage.getItem(STATE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;

      // TTL de 31 dias — descarta state stale baseado em updatedAt (ou startedAt como fallback)
      var lastTouch = parsed.updatedAt || parsed.startedAt;
      if (lastTouch) {
        var t = Date.parse(lastTouch);
        if (!isNaN(t) && (Date.now() - t) > STATE_TTL_MS) {
          try { localStorage.removeItem(STATE_KEY); } catch (_) {}
          return null;
        }
      }

      // Migrações:
      //  V1 (5 telas, sem 'frequencia')                                 → V4 (12 telas)
      //  V2 (10 telas, com 'frequencia' mas sem 'principalDor')        → V4: shift >=2 por +2
      //  V3 (11 telas, com 'principalDor' mas sem 'acneNivel')         → V4: shift >=3 por +1
      var hasFreq = parsed.answers && Object.prototype.hasOwnProperty.call(parsed.answers, 'frequencia');
      var hasPrincipal = parsed.answers && Object.prototype.hasOwnProperty.call(parsed.answers, 'principalDor');
      var hasAcneNivel = parsed.answers && Object.prototype.hasOwnProperty.call(parsed.answers, 'acneNivel');
      if (!hasFreq && typeof parsed.step === 'number' && parsed.step >= 1 && parsed.step <= 5) {
        // V1 → V4
        var v1Map = { 1: 1, 2: 7, 3: 9, 4: 4, 5: 12 };
        parsed.step = v1Map[parsed.step] || 1;
      } else if (hasFreq && !hasPrincipal && typeof parsed.step === 'number' && parsed.step >= 2) {
        // V2 → V4: shift +2 (entram principalDor e acneNivel antes)
        parsed.step = parsed.step + 2;
        if (Array.isArray(parsed.answers.dores) && parsed.answers.dores.length === 1) {
          parsed.answers.principalDor = parsed.answers.dores[0];
        }
      } else if (hasPrincipal && !hasAcneNivel && typeof parsed.step === 'number' && parsed.step >= 3) {
        // V3 → V4: shift +1 (entra acneNivel antes)
        parsed.step = parsed.step + 1;
      }

      var init = makeInitialState();
      parsed.answers = Object.assign({}, init.answers, parsed.answers || {});
      if (!Array.isArray(parsed.answers.dores)) parsed.answers.dores = [];
      return parsed;
    } catch (_) { return null; }
  }

  function saveState(state) {
    state.updatedAt = new Date().toISOString();
    try { localStorage.setItem(STATE_KEY, JSON.stringify(state)); } catch (_) {}
  }

  function resetState() {
    try { localStorage.removeItem(STATE_KEY); } catch (_) {}
  }

  /* ----- Helpers ------------------------------------------------------- */

  function isValidEmail(e) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e || '');
  }
  function isValidPhone(p) {
    return (p || '').replace(/\D/g, '').length >= 10;
  }
  function formatPhone(v) {
    var d = (v || '').replace(/\D/g, '').slice(0, 11);
    if (d.length === 0) return '';
    if (d.length <= 2) return '(' + d;
    if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    if (d.length <= 10) return '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }
  function cap(s) { s = s || ''; return s.charAt(0).toUpperCase() + s.slice(1); }

  function escapeHtml(s) {
    s = (s == null ? '' : String(s));
    return s.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function isStepValid(step, answers) {
    switch (step) {
      case 1: return Array.isArray(answers.dores) && answers.dores.length >= 1;
      case 2: return !!answers.principalDor && Array.isArray(answers.dores) && answers.dores.indexOf(answers.principalDor) !== -1;
      case 3: {
        var a = parseInt(answers.acneNivel, 10);
        return !isNaN(a) && a >= 0 && a <= 5;
      }
      case 4: return (answers.nome || '').trim().length >= 2;
      case 5: return true; // interstitial Antes/Depois
      case 6: return !!answers.tomPele;
      case 7: return !!answers.tipoPele;
      case 8: return !!answers.tempoRotina;
      case 9: {
        var n = parseInt(answers.idade, 10);
        return !isNaN(n) && n >= 10 && n <= 99;
      }
      case 10: return !!answers.frequencia;
      case 11: return true; // interstitial Forbes
      case 12: return isValidEmail(answers.email) && isValidPhone(answers.whatsapp);
      default: return false;
    }
  }

  function buildDoresText(dores) {
    if (!dores || dores.length === 0) return '—';
    var labels = [];
    for (var i = 0; i < dores.length; i++) {
      var l = DOR_LABELS[dores[i]];
      if (l) labels.push(l.toLowerCase());
    }
    if (labels.length === 0) return '—';
    if (labels.length === 1) return labels[0];
    if (labels.length === 2) return labels[0] + ' e ' + labels[1];
    return labels.slice(0, -1).join(', ') + ' e ' + labels[labels.length - 1];
  }

  /* ----- GA4 / GTM tracking helper ------------------------------------- */
  /* Loja tem Google Tag GT-TQV89Z6M instalado (Shopify Google & YouTube
     channel) que roteia pra GA4 + Google Ads. Padrão oficial do Google:
     inicializa window.gtag como stub que empurra arguments pro dataLayer.
     Quando o tag script real carrega, processa o queue. Funciona com
     qualquer ordem de carregamento (race condition resolvida).
     Cada chamada é ~1ms — overhead negligível. */
  try {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () { window.dataLayer.push(arguments); };
    }
    // CRÍTICO — Shopify Google channel só instala o wrapper Google Tag (GT-),
    // que não auto-forwarda custom events pra GA4. Aqui registramos a GA4
    // measurement ID como destino explícito do gtag — assim nossos eventos
    // pj_quiz_* chegam direto na propriedade GA4 465836368.
    // send_page_view:false evita duplicar pageviews já enviados pela Shopify.
    window.gtag('js', new Date());
    window.gtag('config', 'G-ZWQE7JHHFY', { send_page_view: false });
  } catch (_) {}

  /* ----- PostHog (real-time analytics + funnels + session replay) -------- */
  /* PostHog é nossa ferramenta principal de análise visual de funil. GA4 fica
     como backup pra Google Ads. Vantagens: real-time (~3s), funnels nativos,
     session recordings.
     - autocapture: false  → não captura cliques/inputs automáticos (economiza
       budget de eventos no free tier — 1M/mês)
     - capture_pageview: false → Shopify já manda pageviews via Web Pixels
     - disable_session_recording: false → mantém recordings (limite separado) */
  try {
    if (!window.posthog || !window.posthog.__loaded) {
      !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing startSessionRecording stopSessionRecording getSessionId getSessionReplayUrl loadToolbar get_property getPersonProperties createPersonProfile opt_in_session_recording opt_out_session_recording has_opted_in_session_recording has_opted_out_session_recording captureException loadSurveys".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
      window.posthog.init('phc_suSec7cKUQQw5JyWRWxmXVcJ9Mzt9q3op3jjq9wnDoD9', {
        api_host: 'https://us.i.posthog.com',
        capture_pageview: false,
        autocapture: false,
        disable_session_recording: false,
        persistence: 'localStorage+cookie'
      });
      // $pageview disparado MANUALMENTE aqui — capture_pageview: false acima desliga
      // o auto-fire do PostHog (que rodava TARDE, depois do SDK carregar do CDN,
      // o que às vezes era depois do pj_quiz_landing → funnel quebrado por timestamp).
      // Fire manual = timestamp congelado AGORA, garantindo que $pageview vem ANTES
      // de pj_quiz_landing (que dispara em DOMContentLoaded). É o "topo de funil"
      // mais cru — o delta $pageview → pj_quiz_landing = "lost patience" (user
      // clicou mas não esperou o quiz inicializar).
      // O funnel macro filtra por $pathname = /pages/diagnostic, então $pageview
      // disparado em result pages (onde diagnostic.js também carrega) não pollui.
      window.posthog.capture('$pageview');
    }
  } catch (_) {}

  function pjTrack(name, params) {
    var eventName = 'pj_quiz_' + name;
    params = params || {};
    // GA4 via gtag (analytics histórica, atrib. de campanhas, Google Ads)
    try {
      window.gtag('event', eventName, params);
    } catch (_) {}
    // PostHog real-time (funnels, session replay, análise diária)
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(eventName, params);
      }
    } catch (_) {}
    // Fallback dataLayer no formato GTM {event:...} — pra futuro caso a loja
    // migre pra GTM (não tira nada do gtag, só adiciona compatibilidade).
    try {
      var payload = { event: eventName };
      for (var k in params) {
        if (params.hasOwnProperty(k)) payload[k] = params[k];
      }
      window.dataLayer.push(payload);
    } catch (_) {}
  }

  /* Extrai um snapshot de answers (SEM PII) pra incluir em eventos como
     pj_quiz_complete e pj_quiz_result_view. Útil pra análise de cohort no
     GA4/Looker (drop-off por dor, idade, tipo de pele, etc). */
  function pjAnswerSummary(state) {
    var a = (state && state.answers) || {};
    return {
      dor_principal: a.principalDor || '',
      acne_nivel:    a.acneNivel || '',
      idade:         a.idade || '',
      tipo_pele:     a.tipoPele || '',
      tempo_rotina:  a.tempoRotina || '',
      frequencia:    a.frequencia || '',
      tom_pele:      a.tomPele || '',
      num_dores:     (a.dores || []).length
    };
  }

  /* Mapa principalDor → kit_code (D01-D08) pra includes em eventos de result */
  var DOR_TO_KIT_CODE = {
    acne:        'D01',
    oleosidade:  'D02',
    saude:       'D03',
    manchas:     'D04',
    vermelhidao: 'D05',
    sinais:      'D06',
    poros:       'D07',
    olheiras:    'D08'
  };

  /* Cached na entrada de uma result page (init) pra usar em wire functions
     sem precisar reler state em cada event handler. */
  var _resultDor = '';
  function _kitCode() { return DOR_TO_KIT_CODE[_resultDor] || ''; }

  /* ----- DOM refs ------------------------------------------------------ */

  var root, quizEl, resultEl;
  var progressFill, progressText;
  var ctaBtn, ctaLabel, prevBtn;
  var stepEls = {};

  /* ----- P1 scroll tracking -------------------------------------------------
     Hipótese: muitos users dropam em P1 sem nem ver os 8 cards (só 4 visíveis
     above-the-fold no mobile). Trackamos se scrollaram + profundidade pra
     validar. Reseta no goToStep(1), captura no exit (goToStep != 1) + pagehide.
  ------------------------------------------------------------------------- */
  var _p1ScrollEnabled = false;
  var _p1MaxScrollY = 0;
  var _p1ScrollFired = false;
  var _p1EnteredAt = 0;
  var _p1CardsTouched = 0;        // contador de cliques em cards (inclui desmarcações)
  var _p1FirstCardClickAt = 0;    // timestamp do 1º clique em card (0 = nunca clicou)
  var _p1DoresMarked = 0;         // qtde de dores marcadas no momento atual

  function _p1OnScroll() {
    if (!_p1ScrollEnabled) return;
    var y = window.scrollY || window.pageYOffset || 0;
    if (y > _p1MaxScrollY) _p1MaxScrollY = y;
    if (!_p1ScrollFired && y > 30) {
      _p1ScrollFired = true;
      pjTrack('p1_scroll_first', {
        depth_px: Math.round(y),
        viewport_h_px: Math.round(window.innerHeight || 0),
        ms_to_scroll: Date.now() - _p1EnteredAt
      });
    }
  }
  // Chamado por wireDoresCards a cada click num card. Mantém contadores
  // que serão emitidos no p1_exit + dispara o first_card_click 1x.
  function _p1NoteCardClick(currentMarkedCount) {
    if (!_p1ScrollEnabled) return;
    _p1CardsTouched++;
    _p1DoresMarked = currentMarkedCount;
    if (_p1FirstCardClickAt === 0) {
      _p1FirstCardClickAt = Date.now();
      pjTrack('p1_first_card_click', {
        ms_to_click: _p1FirstCardClickAt - _p1EnteredAt
      });
    }
  }
  function _p1ScrollStart() {
    _p1ScrollEnabled = true;
    _p1MaxScrollY = 0;
    _p1ScrollFired = false;
    _p1EnteredAt = Date.now();
    _p1CardsTouched = 0;
    _p1FirstCardClickAt = 0;
    _p1DoresMarked = 0;
    try { window.addEventListener('scroll', _p1OnScroll, { passive: true }); } catch (_) {}
  }
  function _p1ScrollExit(exitReason) {
    if (!_p1ScrollEnabled) return;
    _p1ScrollEnabled = false;
    try { window.removeEventListener('scroll', _p1OnScroll); } catch (_) {}
    // Snapshot final do comportamento em P1 — base pra cohort analysis no PostHog
    pjTrack('p1_exit', {
      reason: exitReason || 'unknown',     // 'advance' | 'pagehide' | 'visibility_hidden' | 'unknown'
      scrolled: _p1MaxScrollY > 30,
      max_scroll_px: Math.round(_p1MaxScrollY),
      viewport_h_px: Math.round(window.innerHeight || 0),
      ms_on_step: Date.now() - _p1EnteredAt,
      cards_touched_count: _p1CardsTouched,
      dores_marked_count: _p1DoresMarked,
      ms_to_first_click: _p1FirstCardClickAt > 0 ? (_p1FirstCardClickAt - _p1EnteredAt) : -1
    });
  }
  // Triple-redundancy pra capturar a saída do P1:
  //   1. pagehide — funciona desktop + ~50% mobile
  //   2. visibilitychange — funciona ~95% mobile (lock screen, troca de app)
  //   3. advance — quando user clica Próxima (chamado em goToStep)
  // O _p1ScrollEnabled flag previne firing duplicado.
  try {
    window.addEventListener('pagehide', function () {
      if (_p1ScrollEnabled) _p1ScrollExit('pagehide');
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden' && _p1ScrollEnabled) {
        _p1ScrollExit('visibility_hidden');
      }
    });
  } catch (_) {}

  // Module-level wiring registry. Permite wirar steps on-demand (quando user
  // chega no step via goToStep), em vez de pre-wirar tudo em idle batches
  // que viravam long tasks na CPU lenta simulada do Lighthouse (TBT explodia).
  var _stepWirers = null;
  var _wired = {};
  function wireStepOnce(n) {
    if (!_stepWirers || _wired[n] || !_stepWirers[n]) return;
    _wired[n] = true;
    _stepWirers[n]();
  }

  /* ----- Quiz render --------------------------------------------------- */

  function setProgress(step) {
    var pct = Math.round((step / STEP_COUNT) * 100);
    progressFill.style.width = pct + '%';
    progressText.textContent = pct + '%';
  }

  function showStep(step) {
    for (var n = 1; n <= STEP_COUNT; n++) {
      if (stepEls[n]) stepEls[n].classList.toggle('is-active', n === step);
    }
  }

  function setNextLabel(step) {
    if (step === STEP_COUNT) ctaLabel.textContent = 'Ver resultados';
    else if (INTERSTITIAL_STEPS.indexOf(step) !== -1) ctaLabel.textContent = 'Continuar';
    else ctaLabel.textContent = 'Próxima';
  }

  function setPrevVisible(step) {
    if (step <= 1) prevBtn.setAttribute('hidden', '');
    else prevBtn.removeAttribute('hidden');
  }

  function refreshCta(state) {
    ctaBtn.disabled = !isStepValid(state.step, state.answers);
    // Pulse no CTA quando step 1 tem ao menos 1 dor selecionada.
    // P1 tem droprate gigantesco (~69% em maio/26) — hipótese: usuário marca
    // 1 card e n entende q precisa clicar "Próxima". Pulse dá affordance.
    // (A seta SVG nativa do botão já existe e tem nudge animado — não duplicar
    //  com seta de texto, fica visualmente bugado.)
    var doresLen = (state.answers.dores && state.answers.dores.length) || 0;
    var pulseOn = state.step === 1 && doresLen >= 1;
    ctaBtn.classList.toggle('pj-cta-pulse', pulseOn);
  }

  function goToStep(state, step) {
    if (step < 1) step = 1;
    if (step > STEP_COUNT) { completeQuiz(state); return; }

    // Skip condicional step 2 (Principal Dor): só aparece se dores.length >= 2.
    if (step === 2 && (!Array.isArray(state.answers.dores) || state.answers.dores.length < 2)) {
      if (state.answers.dores && state.answers.dores.length === 1) {
        state.answers.principalDor = state.answers.dores[0];
      } else {
        state.answers.principalDor = '';
      }
      saveState(state);
      if (state.step === 1) { goToStep(state, 3); return; }       // avançando 1→2 → tenta 3
      if (state.step >= 3)  { goToStep(state, 1); return; }       // voltando 3+→2 → vai pro 1
      goToStep(state, 1); return;
    }

    // Skip condicional step 3 (Nível Acne): só aparece se principalDor === 'acne'.
    if (step === 3 && state.answers.principalDor !== 'acne') {
      state.answers.acneNivel = '';
      saveState(state);
      if (state.step <= 2) { goToStep(state, 4); return; }        // avançando 1/2→3 → pula pro 4
      if (state.step >= 4) { goToStep(state, 2); return; }        // voltando 4+→3 → tenta 2 (que pode pular tb)
      goToStep(state, 1); return;
    }

    // P1 scroll tracking — controla via _p1ScrollEnabled como source of truth.
    // Se entrando em P1 e tracking off → start. Se saindo de P1 e tracking on → exit.
    // Idempotente: handler interno checa flag pra evitar listener duplicado.
    if (step === 1 && !_p1ScrollEnabled) {
      _p1ScrollStart();
    } else if (step !== 1 && _p1ScrollEnabled) {
      _p1ScrollExit('advance');
    }

    state.step = step;
    saveState(state);
    // Wira o step on-demand antes de exibir (skip se já wirou).
    // Reduz TBT do init: nada de pre-wire de 12 steps em idle batches.
    wireStepOnce(step);
    showStep(step);
    setProgress(step);
    // GA4: usuário entrou em um step. Param "step" 1-12, "dor_principal"
    // ajuda análise de cohort (quem chegou no step X com dor Y).
    pjTrack('step_view', { step: step, dor_principal: state.answers.principalDor || '' });
    setNextLabel(step);
    setPrevVisible(step);
    refreshCta(state);

    // Sempre volta ao topo ao trocar de step (evita ficar no meio se a step anterior teve scroll)
    try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); } catch (_) { window.scrollTo(0, 0); }

    // Step 2 — Principal Dor: limpa seleção, renderiza só os cards das dores selecionadas
    if (step === 2) {
      state.answers.principalDor = '';
      showPrincipalDorCards(state);
      saveState(state); refreshCta(state);
    }
    // Step 3 — Nível Acne: limpa seleção anterior (consistente com outros singles)
    if (step === 3) {
      state.answers.acneNivel = '';
      var prev3 = stepEls[3].querySelectorAll('.pj-card--acne.is-selected');
      Array.prototype.forEach.call(prev3, function (c) {
        c.classList.remove('is-selected');
        c.setAttribute('aria-checked', 'false');
      });
      saveState(state); refreshCta(state);
    }
    // Step 4 — Nome: foca o input
    if (step === 4) setTimeout(function () { var i = stepEls[4].querySelector('.pj-name-input'); if (i) i.focus(); }, 60);
    // Step 5 — Antes/Depois interstitial: auto-advance após 6s
    if (step === 5) scheduleAdvance(state, 6000);
    // Step 11 — Forbes interstitial: auto-advance após 4s
    if (step === 11) scheduleAdvance(state, 4000);
    // Step 6 — Tom de pele
    if (step === 6) {
      state.answers.tomPele = '';
      var prev6 = stepEls[6].querySelector('.is-selected');
      if (prev6) prev6.classList.remove('is-selected');
      saveState(state); refreshCta(state);
      var tomTitle = stepEls[6].querySelector('.q-title');
      if (tomTitle) {
        var nm6 = (state.answers.nome || '').trim();
        tomTitle.textContent = nm6
          ? cap(nm6) + ', qual destes é mais próximo do seu tom de pele?'
          : 'Qual destes é mais próximo do seu tom de pele?';
      }
    }
    // Step 7 — Tipo de pele
    if (step === 7) {
      state.answers.tipoPele = '';
      var prev7 = stepEls[7].querySelector('.is-selected');
      if (prev7) prev7.classList.remove('is-selected');
      saveState(state); refreshCta(state);
      var tpTitle = stepEls[7].querySelector('.q-title');
      if (tpTitle) {
        var nm7 = (state.answers.nome || '').trim();
        tpTitle.textContent = nm7
          ? 'Sabe seu tipo de pele, ' + cap(nm7) + '?'
          : 'Sabe seu tipo de pele?';
      }
    }
    // Step 8 — Tempo de rotina
    if (step === 8) {
      state.answers.tempoRotina = '';
      var prev8 = stepEls[8].querySelector('.is-selected');
      if (prev8) prev8.classList.remove('is-selected');
      saveState(state); refreshCta(state);
    }
    // Step 9 — Idade
    if (step === 9) {
      var ageGreet = stepEls[9].querySelector('.pj-age-greeting');
      if (ageGreet) {
        var n9 = (state.answers.nome || '').trim();
        ageGreet.textContent = n9 ? cap(n9) + ', ' : '';
      }
      setTimeout(function () { var i = stepEls[9].querySelector('.pj-age-input'); if (i) i.focus(); }, 60);
    }
    // Step 10 — Frequência
    if (step === 10) {
      state.answers.frequencia = '';
      var prev10 = stepEls[10].querySelector('.is-selected');
      if (prev10) prev10.classList.remove('is-selected');
      saveState(state); refreshCta(state);
      var freqGreet = stepEls[10].querySelector('.pj-freq-greeting');
      if (freqGreet) {
        var nm10 = (state.answers.nome || '').trim();
        freqGreet.textContent = nm10 ? ' ' + cap(nm10) : '';
      }
    }
    // Step 12 — Contato: interpola nome no título
    if (step === 12) {
      var contactGreet = stepEls[12].querySelector('.pj-contact-greeting');
      if (contactGreet) {
        var nm12 = (state.answers.nome || '').trim();
        contactGreet.textContent = nm12 ? cap(nm12) + ', última etapa! ' : '';
      }
    }
  }

  /* ----- Google Sheets webhook (coleta de respostas completas, com PII) ---- */
  /* Endpoint do Apps Script web app deployado pelo cliente. Vazio = no-op.
     PostHog (pj_quiz_complete) fica SEM PII pra respeitar LGPD/billing.
     Sheets é a base de leads — recebe nome/email/whatsapp + todas as respostas. */
  var SHEETS_WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycbxFYFMC1u9YF-urrg4l5oGu49AhDRt3aE16QDhB0liV3lHwmrixNrt9vebcd8u1tkux/exec';

  function sendToSheets(state) {
    if (!SHEETS_WEBHOOK_URL) return;
    var a = state.answers || {};
    var utm = { utm_source:'', utm_medium:'', utm_campaign:'', utm_content:'', utm_term:'' };
    try {
      var params = new URLSearchParams(window.location.search);
      Object.keys(utm).forEach(function (k) { utm[k] = params.get(k) || ''; });
    } catch (_) {}
    var payload = {
      timestamp:     new Date().toISOString(),
      started_at:    state.startedAt || '',
      completed_at:  state.completedAt || '',
      nome:          a.nome || '',
      email:         a.email || '',
      whatsapp:      a.whatsapp || '',
      idade:         a.idade || '',
      principal_dor: a.principalDor || '',
      dores:         (a.dores || []).join(','),
      num_dores:     (a.dores || []).length,
      acne_nivel:    a.acneNivel || '',
      tom_pele:      a.tomPele || '',
      tipo_pele:     a.tipoPele || '',
      tempo_rotina:  a.tempoRotina || '',
      frequencia:    a.frequencia || '',
      kit_code:      DOR_TO_KIT_CODE[a.principalDor] || '',
      url:           window.location.href,
      user_agent:    (navigator && navigator.userAgent) || '',
      utm_source:    utm.utm_source,
      utm_medium:    utm.utm_medium,
      utm_campaign:  utm.utm_campaign,
      utm_content:   utm.utm_content,
      utm_term:      utm.utm_term
    };
    try {
      // mode: 'no-cors' porque Apps Script web apps não retornam CORS headers.
      // keepalive: garante que o request completa mesmo com o redirect do
      // showLoadingScreen → result page acontecendo em sequência.
      // Content-Type não setado de propósito (default text/plain evita preflight
      // OPTIONS que Apps Script não responde).
      fetch(SHEETS_WEBHOOK_URL, {
        method: 'POST',
        body: JSON.stringify(payload),
        keepalive: true,
        mode: 'no-cors'
      }).catch(function () {});
    } catch (_) {}
  }

  function completeQuiz(state) {
    state.completedAt = new Date().toISOString();
    saveState(state);
    // GA4/PostHog: evento principal de conclusão. Inclui resumo de answers (sem
    // PII — só categorias) pra análise de cohort. kit_code mapeia dor → produto.
    var summary = pjAnswerSummary(state);
    summary.kit_code = DOR_TO_KIT_CODE[summary.dor_principal] || 'D01';
    pjTrack('complete', summary);
    // Envia respostas COMPLETAS (com PII) pro Google Sheets — base de leads.
    sendToSheets(state);
    showLoadingScreen(state);
  }

  function showLoadingScreen(state) {
    // GA4: viu tela de loading. Permite medir abandono entre completar e
    // chegar na result page (se o user fecha aba durante o vídeo).
    pjTrack('loading_view', { dor_principal: state.answers.principalDor || '' });

    // Inicia prefetch da result page IMEDIATAMENTE — aproveita os ~4s do vídeo
    // de loading pra baixar o HTML completo da result page específica do dor
    // do user (cada dor tem URL própria) em background. Quando o redirect
    // dispara, tudo já tá em cache.
    prefetchResultPage(state);

    var loadingEl = root.querySelector('.pj-loading') || document.querySelector('.pj-loading');
    if (!loadingEl) {
      redirectToResult(state);
      return;
    }
    quizEl.classList.add('hidden');
    loadingEl.classList.remove('hidden');
    // Scroll suave pro topo do loading pra usuário ver o vídeo desde o início
    try {
      loadingEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (_) {
      window.scrollTo(0, 0);
    }

    var nameEl = loadingEl.querySelector('.pj-loading-name');
    if (nameEl) nameEl.textContent = cap((state.answers.nome || 'Você').trim());

    var steps = loadingEl.querySelectorAll('.pj-loading-steps li');
    var video = loadingEl.querySelector('.pj-loading-video');

    var fallbackDurationMs = 5000;
    var redirected = false;
    var stepsScheduled = false;
    var stepTimers = [];

    function go() {
      if (redirected) return;
      redirected = true;
      redirectToResult(state);
    }

    function clearStepTimers() {
      for (var i = 0; i < stepTimers.length; i++) clearTimeout(stepTimers[i]);
      stepTimers = [];
    }

    function scheduleStepsForDuration(totalMs) {
      if (stepsScheduled) return;
      stepsScheduled = true;
      // 4 checkmarks distribuídos uniformemente DENTRO da duração total
      // (último em ~95% pra garantir que ele apareça antes do redirect)
      var stops = [0.05, 0.30, 0.60, 0.92];
      for (var i = 0; i < steps.length; i++) {
        (function (idx) {
          var t = setTimeout(function () {
            if (steps[idx]) steps[idx].classList.add('is-visible');
          }, Math.round(totalMs * stops[idx]));
          stepTimers.push(t);
        })(i);
      }
    }

    function tryPlay() {
      if (!video) return;
      // Garantias de autoplay: muted + playsinline já estão no markup;
      // forçamos via JS pra cobrir browsers/contextos que ignoram o autoplay attr.
      try { video.muted = true; video.playsInline = true; video.setAttribute('playsinline', ''); } catch (_) {}
      var p;
      try { p = video.play(); } catch (e) { p = null; }
      if (p && p.then) {
        p.then(function () {
          // play OK
        }).catch(function (err) {
          // autoplay bloqueado — deixa o fallback timer cuidar
          console.warn('pj-loading: video.play() rejected', err && err.name);
        });
      }
    }

    if (video) {
      // Quando soubermos a duração real, agendamos os checks proporcionalmente
      video.addEventListener('loadedmetadata', function () {
        var ms = (video.duration && isFinite(video.duration) && video.duration > 0.5)
          ? Math.round(video.duration * 1000)
          : fallbackDurationMs;
        scheduleStepsForDuration(ms);
      });
      // Quando vídeo terminar, redireciona
      video.addEventListener('ended', go);
      // Erro no vídeo: usa timing fallback
      video.addEventListener('error', function () {
        scheduleStepsForDuration(fallbackDurationMs);
        setTimeout(go, fallbackDurationMs + 200);
      });
      // Se metadata não vier em 1.2s, agenda com fallback
      setTimeout(function () {
        if (!stepsScheduled) scheduleStepsForDuration(fallbackDurationMs);
      }, 1200);
      // Hard stop: se ended não disparar em 9s (qualquer motivo), redireciona
      setTimeout(go, 9000);
      // Tenta dar play imediatamente E em resposta ao loadeddata (cobre Safari mobile)
      tryPlay();
      video.addEventListener('loadeddata', tryPlay);
      video.addEventListener('canplay', tryPlay);
    } else {
      scheduleStepsForDuration(fallbackDurationMs);
      setTimeout(go, fallbackDurationMs + 200);
    }
  }

  /* Mapa principalDor → URL da result page específica. Cada dor tem uma page
     própria no Shopify com handle opaco (random — sem nome da dor por SEO/privacy)
     + metafields na variant apontando pro produto Shopify do kit. */
  var RESULT_PAGE_BY_DOR = {
    acne:        '/pages/diagnostic-result',
    oleosidade:  '/pages/r-i6n2cym4',
    saude:       '/pages/r-dnjevtgt',
    manchas:     '/pages/r-ziq3sgvq',
    vermelhidao: '/pages/r-7or3bbne',
    sinais:      '/pages/r-zsisl2dg',
    poros:       '/pages/r-llvmv0wy',
    olheiras:    '/pages/r-y96j2r49'
  };
  var DEFAULT_RESULT_PAGE = '/pages/diagnostic-result';

  function getResultPageUrl(state) {
    var dor = state && state.answers && state.answers.principalDor;
    return RESULT_PAGE_BY_DOR[dor] || DEFAULT_RESULT_PAGE;
  }

  function redirectToResult(state) {
    // GA4: marca o redirect efetivo pra result page. Diferente do loading_view,
    // este só dispara quando o vídeo completa (ou hard timeout) — útil pra
    // medir % que pula/fecha durante o loading.
    var dor = (state && state.answers && state.answers.principalDor) || '';
    pjTrack('result_redirect', { dor_principal: dor, kit_code: DOR_TO_KIT_CODE[dor] || '' });
    // Cada dor tem sua própria result page (handle opaco no Shopify) — escolhida
    // pelo principalDor do quiz. O HTML/assets já foram prefetchados pelo
    // prefetchResultPage() (chamado no início do showLoadingScreen), então
    // a transição é instantânea no Chrome (prerender) ou near-instant.
    window.location.href = getResultPageUrl(state);
  }

  function prefetchResultPage(state) {
    // Idempotente — não duplica se já injetou.
    if (document.getElementById('pj-prefetch-result')) return;
    var url = getResultPageUrl(state);

    // 1) Speculation Rules API (Chrome 109+) — prerendera a página inteira
    //    em background tab, com TODOS sub-resources (CSS, JS, fonts, imagens).
    //    Quando o user navega, a swap é literalmente instantânea (sem network).
    try {
      if (typeof HTMLScriptElement !== 'undefined' &&
          HTMLScriptElement.supports &&
          HTMLScriptElement.supports('speculationrules')) {
        var spec = document.createElement('script');
        spec.id = 'pj-prefetch-result';
        spec.type = 'speculationrules';
        spec.textContent = JSON.stringify({
          prerender: [{
            source: 'list',
            urls: [url]
          }]
        });
        document.head.appendChild(spec);
        return;
      }
    } catch (_) { /* segue pro fallback */ }

    // 2) Fallback universal: <link rel="prefetch"> — baixa o HTML em low-priority.
    try {
      var link = document.createElement('link');
      link.id = 'pj-prefetch-result';
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document';
      document.head.appendChild(link);
    } catch (_) {}

    // 3) Belt-and-suspenders: fetch() de prioridade baixa pra forçar cache HTTP.
    try {
      if (typeof fetch === 'function') {
        var opts = { credentials: 'same-origin', cache: 'force-cache' };
        try { opts.priority = 'low'; } catch (_) {}
        fetch(url, opts).catch(function () {});
      }
    } catch (_) {}
  }

  /* Auto-advance — usado em single-select (350ms) e em interstitial Forbes (2000ms) */
  var advanceTimer;
  function scheduleAdvance(state, delay) {
    clearTimeout(advanceTimer);
    var fromStep = state.step;
    var ms = (typeof delay === 'number') ? delay : 350;
    advanceTimer = setTimeout(function () {
      if (state.step === fromStep) goToStep(state, fromStep + 1);
    }, ms);
  }

  /* ----- Result page (Fatia 2B) --------------------------------------- */

  var TEMPO_LABELS = {
    ate_2: '<2 min',
    de_2_a_3: '2-3 min',
    de_3_a_5: '3-5 min'
  };

  /* SVG icons inline (16px viewBox 24x24) — uma string pronta por chave de chip */
  var CHIP_ICON_AGE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 21v-8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v8"></path><line x1="4" y1="21" x2="20" y2="21"></line><path d="M9 5a3 3 0 1 1 6 0c0 1.5-1 2-1.5 3"></path></svg>';
  var CHIP_ICON_TIME = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><polyline points="12 7 12 12 15 14"></polyline></svg>';
  var CHIP_ICON_TIPO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2s6 8 6 13a6 6 0 0 1-12 0c0-5 6-13 6-13z"></path></svg>';
  var DOR_ICONS = {
    acne:        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="8" cy="9" r="1.2"></circle><circle cx="15" cy="8" r="1.5"></circle><circle cx="11" cy="14" r="1.2"></circle><circle cx="16" cy="15" r="1"></circle><circle cx="7" cy="15" r="1"></circle></svg>',
    oleosidade:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3s5 6 5 11a5 5 0 0 1-10 0c0-5 5-11 5-11z"></path></svg>',
    saude:       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-7-4-7-11a4 4 0 0 1 7-2.5A4 4 0 0 1 19 10c0 7-7 11-7 11z"></path></svg>',
    poros:       '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="7" cy="8" r="1.5"></circle><circle cx="14" cy="9" r="1.5"></circle><circle cx="10" cy="15" r="1.5"></circle><circle cx="17" cy="14" r="1.5"></circle></svg>',
    manchas:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2l2.5 6 6.5.5-5 4.5 1.5 6.5-5.5-3.5-5.5 3.5 1.5-6.5-5-4.5 6.5-.5z"></path></svg>',
    vermelhidao: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M8 14a4 4 0 0 0 8 0"></path></svg>',
    sinais:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8c4 0 4 2 8 2s4-2 8-2"></path><path d="M4 14c4 0 4 2 8 2s4-2 8-2"></path></svg>',
    olheiras:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z"></path><circle cx="12" cy="12" r="3"></circle></svg>'
  };

  function renderResultPage(state) {
    var ans = state.answers || {};
    // SOMENTE principalDor é essencial — define o kit. Tudo o resto tem fallback.
    // ANTES: validava nome+idade+tipoPele+dores → returning users de versão antiga
    // ficavam em loop OU tela branca (quando redirect interno hit safety lock
    // recém-armado pelo init() e abortava sem nunca remover .hidden do pj-result).
    // Agora: se principalDor missing, redirect SEM lock guard (lock só protege loops
    // user-visible); se tudo OK, popula defaults e segue render.
    if (!ans.principalDor) {
      // Sem dor principal: não dá pra escolher kit. Fallback ao quiz.
      // Sem lock guard aqui pra evitar render-em-branco: prefere loop visível
      // ao usuário ficar travado numa página sem conteúdo. Init()'s lock segura.
      window.location.href = '/pages/diagnostic';
      return;
    }
    // Defaults pra campos não-críticos (não bloqueia render)
    if (!Array.isArray(ans.dores) || ans.dores.length === 0) {
      ans.dores = [ans.principalDor]; // backfill da principal — render funciona com array de 1
      state.answers.dores = ans.dores; // persiste pra próximos renders
      saveState(state);
    }
    if (!ans.nome) ans.nome = 'Você';
    if (!ans.idade) ans.idade = '';
    if (!ans.tipoPele) ans.tipoPele = 'naosei';

    // GA4: viu a result page (após render). Inclui o kit_code (D01-D08) pra
    // permitir funil por kit no Looker. Este é o "fundo de funil" antes do
    // CTA → add_to_cart → purchase.
    var summary = pjAnswerSummary(state);
    summary.kit_code = DOR_TO_KIT_CODE[summary.dor_principal] || 'D01';
    pjTrack('result_view', summary);

    // quizEl pode ser null na result page (markup do quiz não é renderizado lá)
    if (quizEl) quizEl.classList.add('hidden');
    resultEl.classList.remove('hidden');

    var nameEl = resultEl.querySelector('.pj-r-name');
    if (nameEl) nameEl.textContent = cap(ans.nome);
    var kitNameEl = resultEl.querySelector('.pj-r-kit-name');
    if (kitNameEl) kitNameEl.textContent = cap(ans.nome);
    var routineNameEl = resultEl.querySelector('.pj-r-routine-name');
    if (routineNameEl) routineNameEl.textContent = cap(ans.nome);

    var chipsEl = resultEl.querySelector('.pj-r-chips');
    if (chipsEl) {
      var chips = '';
      var principalDor = ans.principalDor;
      // 1. Dor principal — destaque com fundo escuro
      if (principalDor && DOR_LABELS[principalDor]) {
        var icoP = DOR_ICONS[principalDor] || '';
        chips += '<span class="pj-r-chip pj-r-chip--primary">' + icoP + escapeHtml(DOR_LABELS[principalDor]) + '</span>';
      }
      // 2. Outras dores (sem a principal)
      for (var i = 0; i < ans.dores.length; i++) {
        var dorKey = ans.dores[i];
        if (dorKey === principalDor) continue;
        var l = DOR_LABELS[dorKey];
        var ico = DOR_ICONS[dorKey] || '';
        if (l) chips += '<span class="pj-r-chip">' + ico + escapeHtml(l) + '</span>';
      }
      // 3. Tipo de pele (esconde se 'naosei')
      if (ans.tipoPele && ans.tipoPele !== 'naosei' && TIPO_PELE_LABELS[ans.tipoPele]) {
        chips += '<span class="pj-r-chip">' + CHIP_ICON_TIPO + 'Pele ' + escapeHtml(TIPO_PELE_LABELS[ans.tipoPele]) + '</span>';
      }
      // 4. Idade (esconde se vazio — pode acontecer em returning users de versão antiga)
      if (ans.idade) {
        chips += '<span class="pj-r-chip">' + CHIP_ICON_AGE + escapeHtml(ans.idade) + ' anos</span>';
      }
      // 5. Tempo de rotina
      if (ans.tempoRotina && TEMPO_LABELS[ans.tempoRotina]) {
        chips += '<span class="pj-r-chip">' + CHIP_ICON_TIME + escapeHtml(TEMPO_LABELS[ans.tempoRotina]) + '</span>';
      }
      chipsEl.innerHTML = chips;
    }

    var iaText = resultEl.querySelector('.pj-r-ia-text');
    if (iaText) {
      var nome = escapeHtml(cap(ans.nome));
      var tempoLabel = escapeHtml(TEMPO_LABELS[ans.tempoRotina] || '2-3 min');
      // Se tipoPele === 'naosei' (ou ausente), omite "tipo X" da frase de abertura.
      var tipoLabel = (ans.tipoPele && ans.tipoPele !== 'naosei')
        ? (TIPO_PELE_LABELS[ans.tipoPele] || '').toLowerCase()
        : '';
      var doresText = escapeHtml(buildDoresText(ans.dores));

      // PARÁGRAFO 1 — Diagnóstico + raiz biológica + sequência de tratamento
      var p1Subject = tipoLabel
        ? 'pele ' + escapeHtml(tipoLabel) + ' com ' + doresText
        : 'sua pele com ' + doresText;
      var p1 = nome + ', ' + p1Subject + ' tem uma raiz biológica: produção desbalanceada de sebo que entope poros e dispara inflamação. A solução existe — só exige a sequência certa, limpar → tratar → restaurar, com produtos formulados pra atacar o problema sem agredir a pele.';

      // PARÁGRAFO 2 — Os 3 kits: Starter (base), Core (+Renova), Pro (+Hidratante matinal)
      var p2 = 'Foi exatamente o que desenvolvemos com dermatologistas em 3 kits, pensados pros seus ' + tempoLabel + '. Todos têm a base completa pra controlar a acne — limpeza, tratamento antiacne e o sérum uniformizador noturno que clareia as marcas que já estão na pele. O Core acrescenta o Renova, gel esfoliante facial que acelera a renovação celular e potencializa todos os outros ativos. O Pro soma ainda o hidratante matinal, que recompõe a barreira durante o dia e quebra o ciclo "pele desidratada produz mais sebo" — o passo que separa controlar a acne de transformar a pele.';

      // PARÁGRAFO 3 — Prova social + resultado esperado
      var p3 = 'Em 30-60 dias você entende por que mais de 100 mil homens abandonaram o esquema de farmácia genérica e construíram a rotina deles aqui dentro.';

      // Short = só o 1º parágrafo (diagnóstico). Long = tudo com respiro entre parágrafos.
      var shortText = p1;
      var longText = p1 + '<br><br>' + p2 + '<br><br>' + p3;
      iaText.dataset.short = shortText;
      iaText.dataset.long = longText;
      iaText.innerHTML = shortText + ' <a href="#" class="pj-r-ia-more" data-state="short">ver mais</a>';
    }
  }

  function wireIaMore() {
    var iaText = resultEl.querySelector('.pj-r-ia-text');
    if (!iaText) return;
    iaText.addEventListener('click', function (e) {
      var link = e.target.closest('.pj-r-ia-more');
      if (!link) return;
      e.preventDefault();
      var state = link.dataset.state;
      if (state === 'short') {
        iaText.innerHTML = iaText.dataset.long + ' <a href="#" class="pj-r-ia-more" data-state="long">ver menos</a>';
      } else {
        iaText.innerHTML = iaText.dataset.short + ' <a href="#" class="pj-r-ia-more" data-state="short">ver mais</a>';
      }
    });
  }

  function wireResultRestart() {
    var btn = resultEl.querySelector('.pj-r-restart');
    if (!btn) return;
    btn.addEventListener('click', function () {
      // GA4: user clicou em "refazer o teste". Sinal de insatisfação com o
      // kit recomendado — útil pra investigar se a recomendação foi off.
      pjTrack('restart', { kit_code: _kitCode() });
      resetState();
      window.location.href = '/pages/diagnostic';
    });
  }

  /* Modal "detalhes da assinatura" — abre com [data-modal-open], fecha com [data-modal-close] ou ESC */
  function wireSubscriptionDetailsModal() {
    var trigger = resultEl.querySelector('[data-modal-open="subscription"]');
    var modal = resultEl.querySelector('#pj-r-modal-subscription');
    if (!trigger || !modal) return;
    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    trigger.addEventListener('click', open);
    var closers = modal.querySelectorAll('[data-modal-close]');
    Array.prototype.forEach.call(closers, function (c) {
      c.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* Helpers compartilhados pelo kit principal */
  function getSelectedAlt() {
    return resultEl.querySelector('.pj-r-alt.is-selected');
  }
  function getCurrentMode() {
    var btn = resultEl.querySelector('.pj-r-toggle-btn.is-active');
    return btn ? btn.dataset.mode : 'assinar';
  }
  /* Retorna '1' (mensal) ou '2' (bimestral) baseado no botão de freq ativo. Default '1'. */
  function getCurrentFreq() {
    var active = resultEl.querySelector('.pj-r-freq-btn.is-active');
    return (active && active.dataset.freq) || '1';
  }
  /* Formata número (decimal "135.9" ou "135,90") como string BR sem prefixo R$.
     Retorna '' se não puder fazer parse. */
  function formatPriceBR(raw) {
    if (raw == null) return '';
    var s = String(raw).replace(/\./g, '_').replace(',', '.').replace('_', '.');
    var n = parseFloat(s);
    if (isNaN(n)) return '';
    return n.toFixed(2).replace('.', ',');
  }

  /* Atualiza os preços e o texto de desconto em CADA card de variante conforme modo.
     Em ambos os modos, o "riscado" é o compare_at_price (preço cheio de varejo) —
     deixa o desconto explícito ao olho do user.
     - Mode 'unica': from = compare_at_price, to = v.price (preço Shopify)
     - Mode 'assinar': from = compare_at_price, to = assinatura_price (mostra desconto maior) */
  function updateAltPrices() {
    var mode = getCurrentMode();
    var alts = resultEl.querySelectorAll('.pj-r-alt');
    Array.prototype.forEach.call(alts, function (alt) {
      var fromEl = alt.querySelector('.pj-r-price-from');
      var toEl = alt.querySelector('.pj-r-price-to');
      var discountEl = alt.querySelector('.pj-r-alt-discount');
      if (!fromEl || !toEl) return;

      var compare = parseFloat(String(alt.dataset.priceCompare || '0').replace(/\./g, '').replace(',', '.'));
      var once = parseFloat(String(alt.dataset.priceOnce || '0').replace(/\./g, '').replace(',', '.'));
      var sub = parseFloat(alt.dataset.priceSub || '0');

      var fromN, toN;
      if (mode === 'unica') {
        fromN = compare;
        toN = once;
      } else {
        fromN = compare;
        toN = sub > 0 ? sub : once;
      }
      fromEl.textContent = 'R$ ' + fromN.toFixed(2).replace('.', ',');
      toEl.textContent = 'R$ ' + toN.toFixed(2).replace('.', ',');

      // Atualiza o "% de desconto" preservando o ícone check à esquerda
      if (discountEl && fromN > 0 && toN > 0 && fromN > toN) {
        var pct = Math.round(((fromN - toN) / fromN) * 100);
        var check = discountEl.querySelector('.pj-r-check');
        discountEl.innerHTML = '';
        if (check) discountEl.appendChild(check);
        discountEl.appendChild(document.createTextNode(pct + '% de desconto'));
      }
    });
  }

  /* Calcula % desconto entre compare_at_price e o preço efetivo do modo atual.
     Retorna 0 se não conseguir parsear. */
  function getAltDiscountPct(alt, mode) {
    if (!alt) return 0;
    var compare = parseFloat(String(alt.dataset.priceCompare || '0').replace(/\./g, '').replace(',', '.'));
    var price;
    if (mode === 'unica') {
      price = parseFloat(String(alt.dataset.priceOnce || '0').replace(/\./g, '').replace(',', '.'));
    } else {
      price = parseFloat(alt.dataset.priceSub || '0');
    }
    if (!(compare > 0) || !(price > 0) || price >= compare) return 0;
    return Math.round(((compare - price) / compare) * 100);
  }

  /* Atualiza o texto em 2 linhas do CTA principal:
     - Linha 1 (.pj-r-cta-main): nome do kit ("ASSINAR/COMPRAR SEU KIT [NOME]")
     - Linha 2 (.pj-r-cta-sub): [pill X% OFF] + benefício (cancele / pagamento único) */
  function updateCtaContent() {
    var cta = resultEl.querySelector('.pj-r-cta');
    var alt = getSelectedAlt();
    if (!cta || !alt) return;
    var mainEl = cta.querySelector('.pj-r-cta-main');
    var subEl = cta.querySelector('.pj-r-cta-sub');
    if (!mainEl || !subEl) return;
    var mode = getCurrentMode();
    var kitName = (alt.dataset.kitLabel || '').toUpperCase();
    var discount = getAltDiscountPct(alt, mode);

    // Linha 1: só o nome do kit
    var action = mode === 'unica' ? 'COMPRAR' : 'ASSINAR';
    mainEl.textContent = action + ' SEU KIT ' + kitName;

    // Linha 2: pill de desconto + benefício curto
    subEl.textContent = '';
    if (discount > 0) {
      var pill = document.createElement('span');
      pill.className = 'pj-r-cta-discount';
      pill.textContent = discount + '% OFF';
      subEl.appendChild(pill);
    }
    var benefit = mode === 'unica' ? 'Pagamento único' : 'Cancele quando quiser';
    if (discount > 0) subEl.appendChild(document.createTextNode(' · ' + benefit));
    else subEl.appendChild(document.createTextNode(benefit));
    subEl.style.display = '';
  }

  function updateCtaHref() {
    var cta = resultEl.querySelector('.pj-r-cta');
    var alt = getSelectedAlt();
    if (!cta || !alt) return;
    var mode = getCurrentMode();

    // Modo "compra única" não usa URL externo — adiciona ao cart Shopify on-click
    // (handler delegado em wireCtaCartAdd intercepta e faz /cart/add.js)
    if (mode === 'unica') {
      var variantId = alt.dataset.variantId || '';
      cta.setAttribute('href', variantId ? '/cart/add?id=' + variantId : '/cart');
      cta.removeAttribute('target');
      cta.style.pointerEvents = '';
      cta.style.opacity = '';
      cta.removeAttribute('aria-disabled');
      updateCtaContent();
      syncStickyCta();
      return;
    }

    // Assinar: escolhe entre mensal (freq=1) e bimestral (freq=2)
    var url = getCurrentFreq() === '2'
      ? alt.dataset.guruAssinaturaBimestral
      : alt.dataset.guruAssinatura;
    cta.setAttribute('target', '_blank');
    if (url && url !== '' && url !== '#') {
      cta.setAttribute('href', url);
      cta.style.pointerEvents = '';
      cta.style.opacity = '';
      cta.removeAttribute('aria-disabled');
    } else {
      cta.setAttribute('href', '#');
      cta.style.pointerEvents = 'none';
      cta.style.opacity = '0.45';
      cta.setAttribute('aria-disabled', 'true');
    }
    updateCtaContent();
    syncStickyCta();
  }

  /* Sincroniza o sticky CTA (label + href + aria-disabled) com o CTA principal.
     Sticky usa versão curta em 1 linha: "[ASSINAR/COMPRAR] [NOME] · R$ XX,XX[/mês]" */
  function syncStickyCta() {
    if (!resultEl) return;
    var mainCta = resultEl.querySelector('.pj-r-cta');
    var sticky = resultEl.querySelector('.pj-r-cta-sticky');
    if (!mainCta || !sticky) return;
    var alt = getSelectedAlt();
    var mode = getCurrentMode();
    var label = sticky.querySelector('.pj-r-cta-sticky-label');
    if (label && alt) {
      var kitName = (alt.dataset.kitLabel || '').toUpperCase();
      var action = mode === 'unica' ? 'COMPRAR' : 'ASSINAR';
      label.textContent = action + ' SEU KIT ' + kitName;
    }
    sticky.setAttribute('href', mainCta.getAttribute('href') || '#');
    if (mainCta.getAttribute('aria-disabled') === 'true') {
      sticky.setAttribute('aria-disabled', 'true');
    } else {
      sticky.removeAttribute('aria-disabled');
    }
  }

  /* Sticky CTA: aparece SÓ quando (a) o usuário já passou pelos cards de variante
     (altsViewed: flag persistente, vira true na 1ª vez que .pj-r-alts entra no
     viewport) E (b) o CTA principal está fora do viewport. Evita o sticky
     piscar logo na carga, antes do user ver os kits. */
  function wireStickyCta() {
    var mainCta = resultEl.querySelector('.pj-r-cta');
    var sticky = resultEl.querySelector('.pj-r-cta-sticky');
    if (!mainCta || !sticky) return;
    syncStickyCta();

    // Sticky aparece quando o user passa pelo CTA principal (rect.bottom <= 0,
    // i.e., CTA inteiro acima do topo do viewport). Como .pj-r-alts (kit list)
    // está ANTES do .pj-r-cta no markup, passar pelo CTA implica ter passado
    // pelas alts — não precisa de check separado.
    var ticking = false;
    function update() {
      var rect = mainCta.getBoundingClientRect();
      sticky.classList.toggle('is-visible', rect.bottom <= 0);
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Avalia o estado inicial (ex: bookmark/deeplink com scroll já em baixo)
    update();
  }

  /* Intercepta clicks nos CTAs (principal + sticky) quando modo === 'unica'.
     Adiciona a variante ao cart Shopify e abre o side cart global (window.pjSideCart).
     Modo 'assinar' segue normal pro link externo Guru. */
  function wireCtaCartAdd() {
    function handle(e) {
      var cta = e.target.closest('.pj-r-cta, .pj-r-cta-sticky');
      if (!cta) return;
      // GA4: click no CTA principal. Disparado pra AMBOS os modos (única +
      // assinar) e AMBAS as posições (main + sticky). É o "intent to buy"
      // que precede o add_to_cart (unica) ou redirect Guru (assinar).
      var mode = getCurrentMode();
      var altSel = getSelectedAlt();
      var ctaType = cta.classList.contains('pj-r-cta-sticky') ? 'sticky' : 'main';
      var variantId = altSel ? (altSel.dataset.variantId || '') : '';
      pjTrack('cta_click', {
        type: ctaType,
        mode: mode,
        kit_code: _kitCode(),
        variant_id: variantId,
        freq: mode === 'assinar' ? getCurrentFreq() : ''
      });
      if (mode !== 'unica') {
        // Mode "assinar" — redirect direto pro checkout externo Guru via <a href>.
        // Do POV do funil PostHog esse click único é AMBOS add_to_cart E
        // begin_checkout (não há etapa intermediária de side cart). PostHog usa
        // fetch keepalive automaticamente, então os eventos chegam mesmo com a
        // navegação imediata em sequência.
        var assinarPrice = 0;
        var assinarKitSize = '';
        if (altSel) {
          var pSub = parseFloat(altSel.dataset.priceSub || '0');
          if (!isNaN(pSub) && pSub > 0) {
            assinarPrice = pSub;
          } else {
            var pOnce = parseFloat(String(altSel.dataset.priceOnce || '0').replace(/\./g, '').replace(',', '.'));
            assinarPrice = isNaN(pOnce) ? 0 : pOnce;
          }
          assinarKitSize = altSel.dataset.kitSize || altSel.dataset.size || '';
        }
        var assinarParams = {
          currency: 'BRL',
          value: assinarPrice,
          variant_id: variantId,
          kit_code: _kitCode(),
          kit_size: assinarKitSize,
          mode: 'assinar',
          freq: getCurrentFreq(),
          destination: 'guru'
        };
        pjTrack('add_to_cart', assinarParams);
        pjTrack('begin_checkout', assinarParams);
        return;
      }
      e.preventDefault();
      var alt = altSel;
      if (!alt) return;
      var variantId = parseInt(alt.dataset.variantId, 10);
      if (!variantId) return;
      if (!window.pjSideCart) { console.error('pjSideCart não carregado'); return; }

      // Pega o elemento de label correto: sticky usa .pj-r-cta-sticky-label,
      // CTA principal usa .pj-r-cta-main. Fallback pro próprio cta (legado).
      var label = cta.querySelector('.pj-r-cta-sticky-label')
               || cta.querySelector('.pj-r-cta-main')
               || cta;
      var originalText = label.textContent;
      cta.style.pointerEvents = 'none';
      label.textContent = 'ADICIONANDO...';

      window.pjSideCart.addItem(variantId, 1)
        .then(function () {
          cta.style.pointerEvents = '';
          label.textContent = originalText;
          window.pjSideCart.open();
          // GA4: add_to_cart é evento padrão (recommended event) — populando
          // ele com preço/valor habilita o relatório de Ecommerce do GA4.
          var priceRaw = parseFloat(String(alt.dataset.priceOnce || '0').replace(/\./g, '').replace(',', '.'));
          var value = isNaN(priceRaw) ? 0 : priceRaw;
          pjTrack('add_to_cart', {
            currency: 'BRL',
            value: value,
            variant_id: variantId,
            kit_code: _kitCode(),
            kit_size: alt.dataset.kitSize || alt.dataset.size || '',
            mode: 'unica'
          });
          // GA4 standard event "add_to_cart" (sem prefixo pj_quiz_) — habilita
          // Funil + relatórios de Ecommerce nativos no GA4.
          try {
            if (typeof window.gtag === 'function') {
              window.gtag('event', 'add_to_cart', {
                currency: 'BRL',
                value: value,
                items: [{
                  item_id: String(variantId),
                  item_name: 'Kit Proper Jack ' + (_kitCode() || ''),
                  item_variant: alt.dataset.kitSize || alt.dataset.size || '',
                  price: value,
                  quantity: 1
                }]
              });
            }
          } catch (_) {}
        })
        .catch(function (err) {
          console.error('pj-r-cta /cart/add.js failed:', err);
          cta.style.pointerEvents = '';
          label.textContent = originalText;
        });
    }
    resultEl.addEventListener('click', handle);
  }
  /* Retorna true se estamos em desktop (>=768px) — galeria muda comportamento. */
  function isGalleryDesktop() {
    return window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
  }

  /* Constrói os thumbs da galeria a partir dos .pj-r-gallery-item existentes.
     Envolve em um wrapper com setas prev/next pra scroll horizontal — se todos
     os thumbs visíveis couberem em 1 linha, as setas ficam escondidas (CSS .has-overflow).
     Em mobile o wrapper inteiro fica escondido via CSS. */
  function buildGalleryThumbs() {
    var gallery = resultEl.querySelector('.pj-r-gallery');
    if (!gallery) return;
    var existingWrap = gallery.querySelector('.pj-r-gallery-thumbs-wrap');
    if (existingWrap) existingWrap.remove();
    var items = gallery.querySelectorAll('.pj-r-gallery-item');
    if (!items.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'pj-r-gallery-thumbs-wrap';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'pj-r-gallery-thumbs-arrow pj-r-gallery-thumbs-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Miniaturas anteriores');
    prevBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>';

    var ul = document.createElement('ul');
    ul.className = 'pj-r-gallery-thumbs';
    Array.prototype.forEach.call(items, function (item, idx) {
      var img = item.querySelector('img');
      if (!img) return;
      var li = document.createElement('li');
      li.className = 'pj-r-gallery-thumb';
      li.setAttribute('role', 'button');
      li.setAttribute('tabindex', '0');
      li.dataset.position = item.dataset.position || String(idx + 1);
      li.dataset.variantSet = item.dataset.variantSet || 'all';
      var thumb = document.createElement('img');
      // Usa data-thumb-src (200px) se disponível; fallback pro src normal (800px).
      thumb.src = img.getAttribute('data-thumb-src') || img.getAttribute('src');
      thumb.loading = 'lazy';
      thumb.alt = '';
      li.appendChild(thumb);
      ul.appendChild(li);
    });

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'pj-r-gallery-thumbs-arrow pj-r-gallery-thumbs-arrow--next';
    nextBtn.setAttribute('aria-label', 'Próximas miniaturas');
    nextBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    wrap.appendChild(prevBtn);
    wrap.appendChild(ul);
    wrap.appendChild(nextBtn);
    gallery.appendChild(wrap);

    ul.addEventListener('click', function (e) {
      var thumb = e.target.closest && e.target.closest('.pj-r-gallery-thumb');
      if (!thumb) return;
      var item = resultEl.querySelector('.pj-r-gallery-item[data-position="' + thumb.dataset.position + '"]');
      if (item) setGalleryActiveItem(item);
    });

    // Scroll horizontal via setas
    function step(dir) {
      var firstThumb = ul.querySelector('.pj-r-gallery-thumb:not(.is-hidden)');
      var w = firstThumb ? firstThumb.offsetWidth + 8 : 72;
      ul.scrollBy({ left: dir * w * 3, behavior: 'smooth' });
    }
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });

    // Mostra/esconde setas baseado em overflow
    function updateArrowsVisibility() {
      var hasOverflow = ul.scrollWidth > ul.clientWidth + 2;
      wrap.classList.toggle('has-overflow', hasOverflow);
      if (hasOverflow) {
        wrap.classList.toggle('at-start', ul.scrollLeft <= 1);
        wrap.classList.toggle('at-end', ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 1);
      }
    }
    ul.addEventListener('scroll', updateArrowsVisibility, { passive: true });
    setTimeout(updateArrowsVisibility, 60);
    window.addEventListener('resize', updateArrowsVisibility);
    // Re-check após cada updateGalleryForVariant (thumbs hidden mudam)
    wrap._updateArrows = updateArrowsVisibility;
  }

  /* Marca um item como ativo + sincroniza o thumb correspondente. */
  function setGalleryActiveItem(item) {
    if (!item) return;
    var gallery = resultEl.querySelector('.pj-r-gallery');
    if (!gallery) return;
    Array.prototype.forEach.call(gallery.querySelectorAll('.pj-r-gallery-item'), function (it) {
      it.classList.remove('is-active');
    });
    item.classList.add('is-active');
    Array.prototype.forEach.call(gallery.querySelectorAll('.pj-r-gallery-thumb'), function (t) {
      t.classList.remove('is-active');
    });
    var thumb = gallery.querySelector('.pj-r-gallery-thumb[data-position="' + item.dataset.position + '"]');
    if (thumb) thumb.classList.add('is-active');
  }

  /* Filtra imagens da galeria de acordo com a variante selecionada.
     Cada <li class="pj-r-alt"> tem data-variant-set="3|4|5" (número de produtos),
     e cada <figure class="pj-r-gallery-item"> tem data-variant-set="3|4|5|all".
     Em desktop, ativa o primeiro item visível e sincroniza thumbs. */
  function updateGalleryForVariant() {
    var alt = getSelectedAlt();
    if (!alt) return;
    var vset = alt.dataset.variantSet;
    var items = resultEl.querySelectorAll('.pj-r-gallery-item');
    Array.prototype.forEach.call(items, function (item) {
      var v = item.dataset.variantSet;
      var show = (v === vset) || (v === 'all');
      item.classList.toggle('is-hidden', !show);
    });
    // Mobile: scroll horizontal volta pro início
    var track = resultEl.querySelector('.pj-r-gallery-track');
    if (track) track.scrollLeft = 0;
    // Sincroniza visibilidade dos thumbs (mesma regra)
    Array.prototype.forEach.call(resultEl.querySelectorAll('.pj-r-gallery-thumb'), function (t) {
      var v = t.dataset.variantSet;
      var show = (v === vset) || (v === 'all');
      t.classList.toggle('is-hidden', !show);
    });
    // Desktop: ativa o primeiro item visível + recalcula arrows do strip de thumbs
    if (isGalleryDesktop()) {
      var firstVisible = resultEl.querySelector('.pj-r-gallery-item:not(.is-hidden)');
      if (firstVisible) setGalleryActiveItem(firstVisible);
      var thumbsWrap = resultEl.querySelector('.pj-r-gallery-thumbs-wrap');
      if (thumbsWrap && typeof thumbsWrap._updateArrows === 'function') {
        thumbsWrap.scrollLeft = 0;
        thumbsWrap._updateArrows();
      }
    }
  }
  /* Formata número decimal em BRL ("49.90" -> "R$ 49,90"). */
  function formatBRL(value) {
    var n = parseFloat(value);
    if (isNaN(n)) return '';
    return 'R$ ' + n.toFixed(2).replace('.', ',');
  }

  /* Lista de produtos do kit selecionado, lendo dos accordion items
     da seção "Conheça sua rotina" (mesma variant). Cada item já tem
     data-step-label, data-product-name e data-unit-price. */
  function renderProductsForKit(altEl) {
    if (!altEl) return;
    var allLists = resultEl.querySelectorAll('.pj-r-alt-products');
    Array.prototype.forEach.call(allLists, function (l) { l.innerHTML = ''; });
    var listEl = altEl.querySelector('.pj-r-alt-products');
    if (!listEl) return;
    var vset = altEl.dataset.variantSet;
    var routineGroup = resultEl.querySelector('.pj-r-routine-group[data-variant-set="' + vset + '"]');
    if (!routineGroup) {
      listEl.innerHTML = '';
      return;
    }
    var items = routineGroup.querySelectorAll('.pj-r-accordion-item');
    var html = '';
    for (var i = 0; i < items.length; i++) {
      var stepLabel = items[i].getAttribute('data-step-label') || '';
      var productName = items[i].getAttribute('data-product-name') || '';
      var priceRaw = items[i].getAttribute('data-unit-price') || '';
      var displayName = stepLabel ? (stepLabel + ' — ' + productName) : productName;
      var priceHtml = priceRaw ? formatBRL(priceRaw) : '';
      html += '<li>'
        + '<span class="pj-r-prod-name">1× ' + escapeHtml(displayName) + '</span>'
        + '<span class="pj-r-prod-price">' + escapeHtml(priceHtml) + '</span>'
        + '</li>';
    }
    listEl.innerHTML = html;
  }

  /* Filtra accordion "Conheça sua rotina" pela variante selecionada.
     Cada <ul class="pj-r-routine-group"> tem data-variant-set="3|4|5". */
  function updateRoutineForVariant() {
    var alt = getSelectedAlt();
    if (!alt) return;
    var vset = alt.dataset.variantSet;
    var groups = resultEl.querySelectorAll('.pj-r-routine-group');
    Array.prototype.forEach.call(groups, function (g) {
      if (g.dataset.variantSet === vset) g.removeAttribute('hidden');
      else g.setAttribute('hidden', '');
    });
    updateRoutineBanner();
  }

  /* Atualiza a foto grande no banner topo da seção "Conheça sua rotina"
     com base no item ABERTO da variante visível. Fallback pro placeholder
     se o item não tem imagem ou se nenhum item está aberto. */
  function updateRoutineBanner() {
    var bannerImg = resultEl.querySelector('.pj-r-routine-banner-img');
    var fallback = resultEl.querySelector('.pj-r-routine-banner-fallback');
    if (!bannerImg) return;
    var activeGroup = resultEl.querySelector('.pj-r-routine-group:not([hidden])');
    if (!activeGroup) {
      bannerImg.setAttribute('hidden', '');
      if (fallback) fallback.removeAttribute('hidden');
      return;
    }
    var openItem = activeGroup.querySelector('.pj-r-accordion-item.is-open') || activeGroup.querySelector('.pj-r-accordion-item');
    var src = openItem && openItem.dataset.img ? openItem.dataset.img : '';
    var alt = openItem && openItem.dataset.imgAlt ? openItem.dataset.imgAlt : '';
    if (src) {
      bannerImg.src = src;
      bannerImg.alt = alt;
      bannerImg.removeAttribute('hidden');
      if (fallback) fallback.setAttribute('hidden', '');
    } else {
      bannerImg.setAttribute('hidden', '');
      bannerImg.removeAttribute('src');
      if (fallback) fallback.removeAttribute('hidden');
    }
  }

  function wireKitAlternatives() {
    var alts = resultEl.querySelectorAll('.pj-r-alt');
    if (!alts.length) return;
    Array.prototype.forEach.call(alts, function (alt) {
      alt.addEventListener('click', function () {
        Array.prototype.forEach.call(alts, function (a) { a.classList.remove('is-selected'); });
        alt.classList.add('is-selected');
        renderProductsForKit(alt);
        updateGalleryForVariant();
        updateRoutineForVariant();
        updateCtaHref();
        // GA4: usuário trocou de kit (Starter/Core/Pro). Inclui variant_id pra
        // join com dados de cart no Looker.
        pjTrack('kit_select', {
          variant_id: alt.dataset.variantId || '',
          kit_size: alt.dataset.kitSize || alt.dataset.size || '',
          kit_code: _kitCode()
        });
      });
    });
    // Estado inicial
    var initial = resultEl.querySelector('.pj-r-alt.is-selected') || alts[0];
    if (initial) {
      renderProductsForKit(initial);
      updateGalleryForVariant();
      updateRoutineForVariant();
      updateAltPrices();
      updateCtaHref();
    }
  }

  function wireSubscriptionToggle() {
    var btns = resultEl.querySelectorAll('.pj-r-toggle-btn');
    if (!btns.length) return;
    var freq = resultEl.querySelector('.pj-r-freq');
    var ctaLink = resultEl.querySelector('.pj-r-cta-link');
    var cta = resultEl.querySelector('.pj-r-cta');
    var altsList = resultEl.querySelector('.pj-r-alts');
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(btns, function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        var mode = b.dataset.mode;
        if (mode === 'unica') {
          if (freq) freq.classList.add('is-hidden');
          if (ctaLink) ctaLink.style.display = 'none';
          if (cta) { cta.dataset.mode = 'unica'; }
          if (altsList) altsList.classList.add('is-mode-unica');
        } else {
          if (freq) freq.classList.remove('is-hidden');
          if (ctaLink) ctaLink.style.display = '';
          if (cta) { cta.dataset.mode = 'assinar'; }
          if (altsList) altsList.classList.remove('is-mode-unica');
        }
        updateAltPrices();
        updateCtaHref();
        // GA4: toggle assinatura vs compra única. Mostra preferência do user.
        pjTrack('mode_toggle', { mode: mode, kit_code: _kitCode() });
      });
    });
  }

  function wireFrequencyToggle() {
    var btns = resultEl.querySelectorAll('.pj-r-freq-btn');
    if (!btns.length) return;
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(btns, function (x) { x.classList.remove('is-active'); });
        b.classList.add('is-active');
        // Atualiza o CTA pra apontar pro URL Guru certo (mensal vs bimestral)
        updateCtaHref();
        // GA4: toggle freq mensal vs bimestral. Útil pra ARPU forecast.
        pjTrack('freq_toggle', { freq: b.dataset.freq || '', kit_code: _kitCode() });
      });
    });
  }

  /* Setas da galeria. Mobile: scroll horizontal (peek do próximo).
     Desktop: troca o item ativo ciclando entre os visíveis. */
  function wireGalleryArrows() {
    var prev = resultEl.querySelector('.pj-r-gallery-arrow--prev');
    var next = resultEl.querySelector('.pj-r-gallery-arrow--next');
    var track = resultEl.querySelector('.pj-r-gallery-track');
    if (!track) return;

    function step(dir) {
      if (isGalleryDesktop()) {
        var visibleItems = [];
        Array.prototype.forEach.call(resultEl.querySelectorAll('.pj-r-gallery-item'), function (it) {
          if (!it.classList.contains('is-hidden')) visibleItems.push(it);
        });
        if (!visibleItems.length) return;
        var activeIdx = -1;
        for (var i = 0; i < visibleItems.length; i++) {
          if (visibleItems[i].classList.contains('is-active')) { activeIdx = i; break; }
        }
        if (activeIdx < 0) activeIdx = 0;
        var newIdx = (activeIdx + dir + visibleItems.length) % visibleItems.length;
        setGalleryActiveItem(visibleItems[newIdx]);
      } else {
        var firstVisible = track.querySelector('.pj-r-gallery-item:not(.is-hidden)');
        var sw = firstVisible ? firstVisible.offsetWidth + 14 : track.clientWidth * 0.9;
        track.scrollBy({ left: dir * sw, behavior: 'smooth' });
      }
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }
  /* Legado mantido pra compat — chamada do init segue, mas sem efeito agora. */
  function wireGalleryThumbs() { /* substituído por wireGalleryArrows */ }

  /* Pós-processa o texto cru da descrição:
     - Divide em parágrafos por <br><br> (quebras duplas)
     - Linha terminando em "?" vira heading bold
     - Linhas após o heading (sem ponto final no padrão de lista) viram bullets
     - Auto-bold da primeira frase do primeiro parágrafo */
  function enhanceRoutineDescriptions() {
    var descs = resultEl.querySelectorAll('.pj-r-acc-desc');
    Array.prototype.forEach.call(descs, function (desc) {
      if (desc.dataset.enhanced) return;
      desc.dataset.enhanced = '1';
      var raw = desc.innerHTML;
      var paragraphs = raw.split(/<br\s*\/?>\s*<br\s*\/?>/i);
      var html = '';
      for (var pIdx = 0; pIdx < paragraphs.length; pIdx++) {
        var lines = paragraphs[pIdx].split(/<br\s*\/?>/i)
          .map(function (l) { return l.trim(); })
          .filter(function (l) { return l.length > 0; });
        if (!lines.length) continue;
        var first = lines[0];
        var firstText = first.replace(/<[^>]+>/g, '').trim();
        var firstEndsQ = /\?\s*$/.test(firstText);
        if (firstEndsQ && lines.length > 1) {
          html += '<p class="pj-r-acc-heading">' + first + '</p>';
          html += '<ul class="pj-r-acc-bullets">';
          for (var i = 1; i < lines.length; i++) {
            var li = lines[i].replace(/^[-•·–]\s*/, '').replace(/[,;.]$/, '');
            html += '<li>' + li + '</li>';
          }
          html += '</ul>';
        } else if (firstEndsQ) {
          html += '<p class="pj-r-acc-heading">' + first + '</p>';
        } else {
          var content = lines.join('<br>');
          if (pIdx === 0) {
            var m = content.match(/^([^.!?]+[.!?])(\s*)([\s\S]*)$/);
            if (m && m[1].length > 6) {
              content = '<strong class="pj-r-acc-lead">' + m[1] + '</strong>' + m[2] + m[3];
            }
          }
          html += '<p>' + content + '</p>';
        }
      }
      desc.innerHTML = html;
    });
  }

  /* Botão "Ver composição" abre modal compartilhado #pj-r-modal-composition
     populado dinamicamente com o nome+tamanho do produto + lista de ingredientes. */
  function wireRoutineComposition() {
    var modal = resultEl.querySelector('#pj-r-modal-composition');
    if (!modal) return;
    var titleEl = modal.querySelector('[data-comp-modal-name]');
    var sizeEl = modal.querySelector('[data-comp-modal-size]');
    var bodyEl = modal.querySelector('[data-comp-modal-body]');

    function openModal(name, size, contentHtml) {
      if (titleEl) titleEl.textContent = name || '';
      if (sizeEl) {
        if (size) { sizeEl.textContent = size; sizeEl.removeAttribute('hidden'); }
        else { sizeEl.textContent = ''; sizeEl.setAttribute('hidden', ''); }
      }
      if (bodyEl) bodyEl.innerHTML = renderCompositionList(contentHtml);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    /* Converte conteúdo cru (com <br>) em lista de ingredientes ou prosa. */
    function renderCompositionList(raw) {
      if (!raw) return '';
      var lines = raw.split(/<br\s*\/?>/i)
        .map(function (l) { return l.trim(); })
        .filter(function (l) { return l.length > 0; });
      // Se tem múltiplas linhas curtas, trata como lista
      if (lines.length > 1) {
        var html = '<ul class="pj-r-comp-list">';
        for (var i = 0; i < lines.length; i++) {
          html += '<li>' + lines[i].replace(/^[-•·–]\s*/, '') + '</li>';
        }
        html += '</ul>';
        return html;
      }
      // Senão, prosa
      return '<p class="pj-r-comp-prose">' + lines.join('<br>') + '</p>';
    }

    var btns = resultEl.querySelectorAll('.pj-r-acc-comp-btn[data-comp-open]');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var name = btn.getAttribute('data-comp-name') || '';
        var size = btn.getAttribute('data-comp-size') || '';
        var tpl = btn.nextElementSibling;
        var raw = (tpl && tpl.tagName === 'TEMPLATE') ? tpl.innerHTML : '';
        openModal(name, size, raw);
        // GA4: abriu modal de composição/ingredientes do produto. Sinal forte
        // de intenção — user está mergulhando no produto antes de comprar.
        pjTrack('composition_view', { product_name: name, kit_code: _kitCode() });
      });
    });

    var closers = modal.querySelectorAll('[data-modal-close]');
    Array.prototype.forEach.call(closers, function (c) {
      c.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  function wireRoutineAccordion() {
    var items = resultEl.querySelectorAll('.pj-r-accordion-item');
    if (!items.length) return;
    Array.prototype.forEach.call(items, function (item) {
      var btn = item.querySelector('.pj-r-accordion-btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');
        // Comportamento accordion: fechar os irmãos da mesma group quando abrir um novo
        if (willOpen) {
          var group = item.parentElement;
          if (group) {
            Array.prototype.forEach.call(group.querySelectorAll('.pj-r-accordion-item.is-open'), function (sibling) {
              if (sibling !== item) {
                sibling.classList.remove('is-open');
                var sBtn = sibling.querySelector('.pj-r-accordion-btn');
                if (sBtn) sBtn.setAttribute('aria-expanded', 'false');
              }
            });
          }
        }
        item.classList.toggle('is-open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) {
          updateRoutineBanner();
          // GA4: abriu o accordion de um passo da rotina (manhã/noite).
          // step_label vem do data attribute do item (ex: "Limpe", "Hidrate").
          pjTrack('routine_open', {
            routine_step: item.getAttribute('data-step-label') || item.getAttribute('data-routine-step') || '',
            kit_code: _kitCode()
          });
        }
      });
    });
  }

  function wireSliderArrows() {
    var arrows = resultEl.querySelectorAll('.pj-r-slider-arrow');
    var sliderMap = {
      ad: '.pj-r-ad-slider',
      benefit: '.pj-r-benefits-slider',
      video: '.pj-r-video-slider'
    };
    Array.prototype.forEach.call(arrows, function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.target;
        var dir = btn.classList.contains('pj-r-slider-arrow--prev') ? -1 : 1;
        var slider = resultEl.querySelector(sliderMap[key]);
        if (!slider) return;
        var card = slider.querySelector('article');
        var step = card ? card.offsetWidth + 12 : slider.clientWidth * 0.85;
        slider.scrollBy({ left: step * dir, behavior: 'smooth' });
      });
    });
  }

  function wireResultAdDots() {
    var slider = resultEl.querySelector('.pj-r-ad-slider');
    var dots = resultEl.querySelectorAll('.pj-r-ad-dot');
    if (!slider || !dots.length) return;
    var cards = slider.querySelectorAll('.pj-r-ad-card');
    if (!cards.length) return;

    // ---- Auto-scroll ----------------------------------------------------
    // Avança 1 card a cada 2.5s. Pausa quando o user interage (touch/drag/click
    // nas arrows) e retoma após 6s de idle. Pausa também quando a section sai
    // do viewport pra não desperdiçar CPU.
    var AUTO_INTERVAL_MS = 2500;
    var RESUME_AFTER_MS = 6000;
    var autoTimer = null;
    var resumeTimer = null;
    var paused = false;
    var inView = false;

    function nextIndex() {
      var center = slider.scrollLeft + slider.clientWidth / 2;
      var current = 0, minDist = Infinity;
      Array.prototype.forEach.call(cards, function (card, i) {
        var c = card.offsetLeft + card.offsetWidth / 2;
        var d = Math.abs(c - center);
        if (d < minDist) { minDist = d; current = i; }
      });
      return (current + 1) % cards.length;
    }
    function scrollToCard(idx) {
      if (idx < 0 || idx >= cards.length) return;
      var card = cards[idx];
      var target = card.offsetLeft - (slider.clientWidth - card.offsetWidth) / 2;
      slider.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }
    function startAuto() {
      stopAuto();
      if (paused || !inView) return;
      autoTimer = setInterval(function () {
        if (paused || !inView) return;
        scrollToCard(nextIndex());
      }, AUTO_INTERVAL_MS);
    }
    function stopAuto() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }
    function pauseAndScheduleResume() {
      paused = true;
      stopAuto();
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; startAuto(); }, RESUME_AFTER_MS);
    }

    // Eventos de interação: pausa o auto-scroll. Inclui touch e mousedown pra
    // pegar drag manual, e click nas arrows é interceptado via delegação no
    // .pj-r-slider-wrap pai.
    slider.addEventListener('touchstart', pauseAndScheduleResume, { passive: true });
    slider.addEventListener('mousedown', pauseAndScheduleResume);
    var wrap = slider.closest('.pj-r-slider-wrap');
    if (wrap) {
      wrap.addEventListener('click', function (e) {
        if (e.target.closest('.pj-r-slider-arrow')) pauseAndScheduleResume();
      });
    }
    // Pausa quando a section sai do viewport (poupa CPU + evita scroll fantasma)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting;
          if (inView) startAuto(); else stopAuto();
        });
      }, { threshold: 0.25 });
      io.observe(slider);
    } else {
      inView = true;
      startAuto();
    }
    // ---- /Auto-scroll ---------------------------------------------------

    var scrollTimer;
    slider.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var center = slider.scrollLeft + slider.clientWidth / 2;
        var closest = 0, minDist = Infinity;
        Array.prototype.forEach.call(cards, function (card, i) {
          var c = card.offsetLeft + card.offsetWidth / 2;
          var d = Math.abs(c - center);
          if (d < minDist) { minDist = d; closest = i; }
        });
        Array.prototype.forEach.call(dots, function (dot, i) {
          dot.classList.toggle('is-active', i === closest);
        });
      }, 60);
    });
  }

  /* Reviews via API Okendo (produto ancora PJ26):
     - Inicial: pega 5 reviews mais recentes
     - "ver mais" pagina via nextUrl que o Okendo retorna
     - Renderiza no markup existente .pj-r-reviews-list mantendo o estilo do tema */
  var OKENDO_STAR_SVG = '<svg viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>';
  var OKENDO_STAR_EMPTY_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>';
  function okendoStarsFor(rating) {
    var r = parseInt(rating, 10);
    if (isNaN(r) || r < 0) r = 5;
    if (r > 5) r = 5;
    var s = '';
    for (var i = 1; i <= 5; i++) s += (i <= r) ? OKENDO_STAR_SVG : OKENDO_STAR_EMPTY_SVG;
    return s;
  }

  function timeAgoPt(dateStr) {
    var d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    var sec = Math.floor((Date.now() - d.getTime()) / 1000);
    var months = Math.floor(sec / (30 * 24 * 3600));
    if (months >= 12) {
      var years = Math.floor(months / 12);
      return years + (years === 1 ? ' ano atrás' : ' anos atrás');
    }
    if (months >= 1) return months + (months === 1 ? ' mês atrás' : ' meses atrás');
    var days = Math.floor(sec / (24 * 3600));
    if (days >= 1) return days + (days === 1 ? ' dia atrás' : ' dias atrás');
    var hrs = Math.floor(sec / 3600);
    if (hrs >= 1) return hrs + (hrs === 1 ? ' hora atrás' : ' horas atrás');
    return 'agora há pouco';
  }

  /* Play/pause dos vídeos de depoimento.
     - Click no botão → toggle play do vídeo daquele card
     - Quando inicia um, pausa os outros
     - Estado é sincronizado via events nativos play/pause/ended (mais robusto que tracking manual). */
  function wireVideoTestimonials() {
    var cards = resultEl.querySelectorAll('.pj-r-video-card');
    if (!cards.length) return;
    Array.prototype.forEach.call(cards, function (card) {
      var videoEl = card.querySelector('.pj-r-video-el');
      var btnEl = card.querySelector('[data-video-toggle]');
      if (!videoEl || !btnEl) return;

      // iOS Safari + preload="metadata" não renderiza o primeiro frame como poster
      // por default — só mostra o background cream. Solução: ao receber metadata,
      // seek pra 0.1s pra forçar o decode do primeiro frame, que vira o "thumbnail"
      // visível enquanto o vídeo não toca. Usa `seeked` pra confirmar antes de
      // marcar como pronto (alguns browsers só renderizam após o seek completar).
      var posterShown = false;
      function showPoster() {
        if (posterShown) return;
        try {
          // Pula pro 1º frame visível — currentTime=0 nem sempre renderiza.
          videoEl.currentTime = 0.1;
        } catch (_) { /* alguns browsers exigem que metadata esteja carregada */ }
      }
      videoEl.addEventListener('loadedmetadata', showPoster);
      videoEl.addEventListener('seeked', function () {
        posterShown = true;
        card.classList.add('has-poster');
      });

      // Lazy-load REAL: o markup vem com preload="none" e data-src (sem <source>
      // tag). Aqui injetamos a <source> tag + chamamos load() quando o card
      // entra no viewport via IntersectionObserver. Sem isso, 5 vídeos HD-720p
      // baixavam metadata (~700KB cada) no page load mesmo escondidos.
      function injectSourceAndLoad() {
        var dataSrc = videoEl.getAttribute('data-src');
        if (!dataSrc || videoEl.querySelector('source')) return;
        var source = document.createElement('source');
        source.src = dataSrc;
        source.type = 'video/mp4';
        videoEl.appendChild(source);
        try { videoEl.preload = 'metadata'; videoEl.load(); } catch (_) {}
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              injectSourceAndLoad();
              io.unobserve(videoEl);
            }
          });
        }, { rootMargin: '200px 0px' });
        io.observe(videoEl);
      } else {
        injectSourceAndLoad();
      }

      function pauseAllOthers() {
        Array.prototype.forEach.call(cards, function (c) {
          if (c === card) return;
          var v = c.querySelector('.pj-r-video-el');
          if (v && !v.paused) v.pause();
        });
      }
      function tryPlay() {
        pauseAllOthers();
        // Garante que a <source> foi injetada (caso o user clique em play antes
        // do IntersectionObserver disparar — improvável mas possível).
        injectSourceAndLoad();
        videoEl.muted = false;
        var p = videoEl.play();
        if (p && p.then) p.catch(function () { /* autoplay blocked: silent */ });
        // GA4: user iniciou play em um depoimento. video_id (ou src) pra
        // diferenciar quais vídeos performam melhor como social proof.
        var src = videoEl.getAttribute('data-src') || videoEl.currentSrc || '';
        var videoId = src.split('/').pop().split('?')[0];
        pjTrack('video_play', { video_id: videoId, kit_code: _kitCode() });
      }
      // Toggle usa a class `is-playing` como source of truth em vez de
      // videoEl.paused — mais robusto porque reflete o estado VISUAL/de
      // evento, não estado interno volátil do browser (que pode estar em
      // transição quando o promise do play() ainda não resolveu).
      function handleToggle() {
        // Source of truth = videoEl.paused (estado nativo do browser), não a
        // class CSS. O evento 'play' adiciona .is-playing async; em iOS Safari
        // o delay era suficiente pro user clicar pause antes da class entrar,
        // fazendo o toggle pular pra tryPlay() em vez de pausar — bug reportado
        // pelo cliente em 19 May ("pause não funciona nem no botão nem no video").
        if (!videoEl.paused) {
          videoEl.pause();
          card.classList.remove('is-playing'); // visual update imediato; native 'pause' event re-confirma
        } else {
          tryPlay();
        }
      }

      // Touch (mobile) → preventDefault no touchend evita click-ghost.
      // Desktop usa click direto. Guard de 400ms entre touch e click pra
      // não duplicar em dispositivos híbridos (Surface, iPad Pro).
      var lastTouchAt = 0;
      btnEl.addEventListener('touchend', function (e) {
        e.preventDefault();
        lastTouchAt = Date.now();
        handleToggle();
      }, { passive: false });
      btnEl.addEventListener('click', function () {
        if (Date.now() - lastTouchAt < 400) return;
        handleToggle();
      });
      // Click no <video> também faz toggle — UX padrão de player. Resolve o
      // caso do user clicar fora do botão pequeno (48px no desktop quando
      // playing) na região visível do vídeo.
      videoEl.addEventListener('click', function () {
        if (Date.now() - lastTouchAt < 400) return;
        handleToggle();
      });
      // Sincroniza .is-playing via events nativos (cobre play/pause via JS ou controls nativos)
      videoEl.addEventListener('play', function () { card.classList.add('is-playing'); });
      videoEl.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      videoEl.addEventListener('ended', function () { card.classList.remove('is-playing'); });
    });
  }

  /* Dots do slider de vídeos: atualiza ao scrollar. */
  function wireVideoDots() {
    var slider = resultEl.querySelector('.pj-r-video-slider');
    var dots = resultEl.querySelectorAll('.pj-r-video-dots span');
    if (!slider || !dots.length) return;
    var cards = slider.querySelectorAll('.pj-r-video-card');
    if (!cards.length) return;
    var scrollTimer;
    slider.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var center = slider.scrollLeft + slider.clientWidth / 2;
        var closest = 0, minDist = Infinity;
        Array.prototype.forEach.call(cards, function (card, i) {
          var c = card.offsetLeft + card.offsetWidth / 2;
          var d = Math.abs(c - center);
          if (d < minDist) { minDist = d; closest = i; }
        });
        Array.prototype.forEach.call(dots, function (d, i) {
          d.classList.toggle('is-active', i === closest);
        });
      }, 60);
    });
  }

  /* Wire de scroll suave pra elementos com [data-scroll-to="<selector>"].
     Click no elemento → window.scrollTo até o destino, com offset pra sticky header. */
  function wireScrollAnchors() {
    var btns = resultEl.querySelectorAll('[data-scroll-to]');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var sel = btn.getAttribute('data-scroll-to');
        var target = resultEl.querySelector(sel) || document.querySelector(sel);
        if (!target) return;
        var rect = target.getBoundingClientRect();
        var y = window.pageYOffset + rect.top - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  /* Infla artificialmente o count de reviews do Okendo (+7.000) e recalcula a distribuição
     proporcional por estrela baseado numa média típica 4.9. Aplica em todos os locais
     onde [data-okendo-count] aparece e nos .pj-r-rd-fill/.pj-r-rd-count das barras. */
  function inflateOkendoCount() {
    var INFLATE = 7000;
    // distribuição proporcional pra média ~4.9 (95% 5★, 3% 4★, 1% 3★, 0.4% 2★, 0.6% 1★)
    var DIST = { 5: 0.95, 4: 0.03, 3: 0.01, 2: 0.004, 1: 0.006 };

    var countEls = resultEl.querySelectorAll('[data-okendo-count]');
    if (!countEls.length) return;
    var rawText = (countEls[0].textContent || '0').replace(/\D/g, '');
    var realCount = parseInt(rawText, 10);
    if (!realCount || isNaN(realCount)) return;

    var inflated = realCount + INFLATE;
    var formatPt = function (n) {
      try { return n.toLocaleString('pt-BR'); }
      catch (e) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
    };
    var formatted = formatPt(inflated);

    Array.prototype.forEach.call(countEls, function (el) { el.textContent = formatted; });

    var distItems = resultEl.querySelectorAll('.pj-r-rating-distribution li');
    var counts = {};
    var maxC = 0;
    Array.prototype.forEach.call(distItems, function (li) {
      var numEl = li.querySelector('.pj-r-rd-num');
      var num = parseInt(numEl ? numEl.textContent : '0', 10);
      if (!num) return;
      var c = Math.round(inflated * (DIST[num] || 0));
      counts[num] = c;
      if (c > maxC) maxC = c;
    });
    Array.prototype.forEach.call(distItems, function (li) {
      var numEl = li.querySelector('.pj-r-rd-num');
      var num = parseInt(numEl ? numEl.textContent : '0', 10);
      var fillEl = li.querySelector('.pj-r-rd-fill');
      var countEl = li.querySelector('.pj-r-rd-count');
      var c = counts[num] || 0;
      var pct = maxC > 0 ? (c / maxC) * 100 : 0;
      if (fillEl) fillEl.style.width = pct.toFixed(1) + '%';
      if (countEl) countEl.textContent = formatPt(c);
    });
  }

  /* Delegação única pra fechar QUALQUER modal via [data-modal-close] ou tecla ESC.
     Substitui os listeners individuais espalhados — mais resiliente. */
  function wireModalCloseDelegation() {
    function closeModalEl(m) {
      if (!m) return;
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    resultEl.addEventListener('click', function (e) {
      var t = e.target;
      while (t && t !== resultEl) {
        if (t.hasAttribute && t.hasAttribute('data-modal-close')) {
          var modal = t;
          while (modal && !(modal.classList && modal.classList.contains('pj-r-modal'))) modal = modal.parentElement;
          closeModalEl(modal);
          return;
        }
        t = t.parentElement;
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = resultEl.querySelectorAll('.pj-r-modal.is-open');
      Array.prototype.forEach.call(open, closeModalEl);
    });
  }

  /* Downsize Okendo CDN dimensions param (?d=1600x1600 → ?d=600x600). */
  function okendoDownsize(url, dim) {
    if (!url) return url;
    var d = dim || 600;
    return url.replace(/([?&])d=\d+x\d+/, '$1d=' + d + 'x' + d);
  }

  /* Lightbox compartilhado pra fotos de reviews (galeria topo + reviews individuais)
     E pra imagens da galeria principal do produto.
     Click em qualquer [data-photo-src] abre o modal #pj-r-modal-photo.
     - Quando não há nome+body (ex: imagens de produto), esconde o bloco meta via .is-image-only.
     - Quando o click vem de dentro de um "grupo" (galeria ou fotos de review com 2+ imgs),
       habilita as setas prev/next que navegam pelas imagens visíveis daquele grupo.
       Teclas ←/→ no teclado também navegam. */
  function wireOkendoPhotoLightbox() {
    var modal = resultEl.querySelector('#pj-r-modal-photo');
    if (!modal) return;
    var imgEl = modal.querySelector('[data-photo-modal-img]');
    var nameEl = modal.querySelector('[data-photo-modal-name]');
    var bodyEl = modal.querySelector('[data-photo-modal-body]');
    var prevBtn = modal.querySelector('[data-photo-prev]');
    var nextBtn = modal.querySelector('[data-photo-next]');
    var openToken = 0; // pra cancelar swap se trocar de foto antes do preload terminar

    // Containers cujas imgs formam um grupo navegável pelas setas.
    var GROUP_SELECTORS = ['.pj-r-gallery-track', '.pj-r-reviews-photos', '.pj-r-review-photos'];
    var currentGroup = []; // [{thumb, large, name, body}, ...]
    var currentIndex = 0;

    function showItem(item) {
      openToken++;
      var token = openToken;
      var smallSrc = okendoDownsize(item.large, 600);
      if (imgEl) {
        imgEl.src = item.thumb || smallSrc;
        imgEl.alt = item.name || 'Foto';
        if (smallSrc && smallSrc !== item.thumb) {
          var preloader = new Image();
          preloader.onload = function () {
            if (token === openToken && modal.classList.contains('is-open')) {
              imgEl.src = smallSrc;
            }
          };
          preloader.src = smallSrc;
        }
      }
      if (nameEl) nameEl.textContent = item.name || '';
      if (bodyEl) {
        if (item.body) { bodyEl.textContent = item.body; bodyEl.removeAttribute('hidden'); }
        else { bodyEl.textContent = ''; bodyEl.setAttribute('hidden', ''); }
      }
      if (!item.name && !item.body) modal.classList.add('is-image-only');
      else modal.classList.remove('is-image-only');
      // Mostra/esconde setas conforme tamanho do grupo
      var hasMulti = currentGroup.length > 1;
      if (prevBtn) { if (hasMulti) prevBtn.removeAttribute('hidden'); else prevBtn.setAttribute('hidden', ''); }
      if (nextBtn) { if (hasMulti) nextBtn.removeAttribute('hidden'); else nextBtn.setAttribute('hidden', ''); }
    }

    function findGroupContainer(el) {
      for (var i = 0; i < GROUP_SELECTORS.length; i++) {
        var c = el.closest && el.closest(GROUP_SELECTORS[i]);
        if (c) return c;
      }
      return null;
    }

    function buildGroupFromTarget(target) {
      var container = findGroupContainer(target);
      if (!container) {
        return {
          group: [{
            thumb: target.getAttribute('src'),
            large: target.getAttribute('data-photo-src'),
            name: target.getAttribute('data-photo-name'),
            body: target.getAttribute('data-photo-body')
          }],
          index: 0
        };
      }
      var els = Array.prototype.slice.call(container.querySelectorAll('[data-photo-src]'))
        .filter(function (el) {
          // Filtra imgs ocultas (variant filter na galeria, ou hidden em geral)
          var item = el.closest('.pj-r-gallery-item');
          if (item && item.classList.contains('is-hidden')) return false;
          if (el.offsetParent === null && !el.classList.contains('pj-r-gallery-img')) return false;
          return true;
        });
      var group = els.map(function (el) {
        return {
          thumb: el.getAttribute('src'),
          large: el.getAttribute('data-photo-src'),
          name: el.getAttribute('data-photo-name'),
          body: el.getAttribute('data-photo-body')
        };
      });
      var idx = els.indexOf(target);
      if (idx < 0) idx = 0;
      return { group: group, index: idx };
    }

    function openFromTarget(target) {
      var result = buildGroupFromTarget(target);
      currentGroup = result.group;
      currentIndex = result.index;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      showItem(currentGroup[currentIndex]);
      // GA4: zoom em foto (galeria principal ou foto de review do Okendo).
      // "source" indica de onde veio o click pra separar engagement com kit vs social proof.
      var container = findGroupContainer(target);
      var source = container
        ? (container.classList.contains('pj-r-gallery-track') ? 'gallery'
          : (container.classList.contains('pj-r-reviews-photos') || container.classList.contains('pj-r-review-photos')) ? 'reviews'
          : 'other')
        : 'single';
      pjTrack('gallery_zoom', { source: source, kit_code: _kitCode() });
    }

    function navigate(delta) {
      if (currentGroup.length < 2) return;
      currentIndex = (currentIndex + delta + currentGroup.length) % currentGroup.length;
      showItem(currentGroup[currentIndex]);
    }

    function closeModal() {
      openToken++;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (imgEl) imgEl.removeAttribute('src');
      currentGroup = [];
      currentIndex = 0;
    }

    resultEl.addEventListener('click', function (e) {
      var t = e.target;
      while (t && t !== resultEl) {
        if (t.hasAttribute && t.hasAttribute('data-photo-src')) {
          e.preventDefault();
          openFromTarget(t);
          return;
        }
        t = t.parentElement;
      }
    });

    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); navigate(-1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); navigate(1);
    });

    var closers = modal.querySelectorAll('[data-modal-close]');
    Array.prototype.forEach.call(closers, function (c) { c.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key === 'ArrowLeft') { navigate(-1); return; }
      if (e.key === 'ArrowRight') { navigate(1); return; }
    });
    if (imgEl) imgEl.addEventListener('click', closeModal);
  }

  function wireOkendoReviews() {
    var section = resultEl.querySelector('.pj-r-reviews');
    if (!section) return;
    var subscriber = section.getAttribute('data-okendo-subscriber');
    var productId = section.getAttribute('data-okendo-product-id');
    var listEl = section.querySelector('[data-okendo-reviews-list]');
    var moreBtn = section.querySelector('[data-okendo-more]');
    var galleryEl = section.querySelector('[data-okendo-photos]');
    var filterBtns = section.querySelectorAll('[data-rev-filter]');
    var verifiedSealUrl = section.getAttribute('data-okendo-verified-seal') || '';
    if (!subscriber || !productId || !listEl) return;

    var BASE = 'https://api.okendo.io';
    var baseUrlPrefix = '/v1/stores/' + subscriber + '/products/' + productId + '/reviews';
    var isFetching = false;
    var allReviews = [];      // cache acumulado de TODAS as reviews já buscadas
    var currentFilter = 'recent';
    var nextUrl = buildInitialUrl('recent');

    /* Constrói URL inicial baseado no filter ativo.
       - 'recent': orderBy=date desc
       - 'photos': orderBy=date desc + filter client-side
       - 'rating-desc': orderBy=rating desc (5★ primeiro)
       - 'rating-asc': orderBy=rating asc (1★ primeiro) */
    function buildInitialUrl(filter) {
      var limit = filter === 'photos' ? 30 : 15;
      var orderBy = 'date+desc';
      if (filter === 'rating-desc') orderBy = 'rating+desc';
      else if (filter === 'rating-asc') orderBy = 'rating+asc';
      return baseUrlPrefix + '?limit=' + limit + '&orderBy=' + orderBy;
    }

    /* Okendo retorna nextUrl como "/stores/..." (sem /v1/), mas a API só responde
       com /v1/ prefixado — sem isso dá 403. */
    function ensureV1(path) {
      if (!path) return path;
      if (path.indexOf('/v1/') === 0) return path;
      if (path.indexOf('/stores/') === 0) return '/v1' + path;
      return path;
    }

    function setMoreState(state) {
      if (!moreBtn) return;
      moreBtn.style.opacity = '';
      if (state === 'loading') {
        moreBtn.textContent = 'carregando…';
        moreBtn.disabled = true;
      } else if (state === 'idle') {
        moreBtn.textContent = 'ver mais avaliações';
        moreBtn.disabled = false;
      } else if (state === 'done') {
        moreBtn.textContent = 'sem mais avaliações';
        moreBtn.disabled = true;
        moreBtn.style.opacity = '0.5';
      } else if (state === 'error') {
        moreBtn.textContent = 'erro ao carregar — tentar novamente';
        moreBtn.disabled = false;
      }
    }

    /* Filtros server-side (rating) já vêm filtrados da API — não precisa refiltrar.
       Filtro 'photos' é client-side (API não suporta) — refiltra do cache. */
    function applyFilter(reviews) {
      if (currentFilter === 'photos') {
        return reviews.filter(function (r) {
          var ms = r.media || [];
          for (var i = 0; i < ms.length; i++) if (ms[i].type === 'image') return true;
          return false;
        });
      }
      return reviews;
    }

    var collectedPhotos = []; // pra galeria topo (sempre lista todas as fotos, independente do filter)
    var galleryPhotos = []; // cache dedicado da galeria topo (independente da lista filtrada)

    /* Fetch dedicado pra galeria de fotos: pega 50 reviews mais recentes e extrai
       todas as fotos. Roda em paralelo com a lista, não interfere com filtros. */
    function loadGalleryPhotos() {
      var url = baseUrlPrefix + '?limit=50&orderBy=date+desc';
      fetch(BASE + ensureV1(url)).then(function (r) {
        return r.ok ? r.json() : null;
      }).then(function (data) {
        if (!data) return;
        var arr = (data && data.reviews) || [];
        galleryPhotos = [];
        for (var i = 0; i < arr.length; i++) {
          var r = arr[i];
          var ms = r.media || [];
          var name = (r.reviewer && r.reviewer.displayName) || 'Cliente Proper';
          var body = (r.body || '').replace(/\s+/g, ' ').trim();
          for (var j = 0; j < ms.length; j++) {
            if (ms[j].type !== 'image') continue;
            var th = ms[j].thumbnailUrl || ms[j].largeUrl || ms[j].fullSizeUrl;
            var fu = ms[j].largeUrl || ms[j].fullSizeUrl || ms[j].thumbnailUrl;
            if (!th) continue;
            galleryPhotos.push({ thumb: th, full: fu, name: name, body: body });
          }
        }
        renderTopGallery();
      }).catch(function () { /* silent */ });
    }

    function renderTopGallery() {
      if (!galleryEl) return;
      if (galleryPhotos.length === 0) { galleryEl.setAttribute('hidden', ''); return; }
      var html = '';
      for (var i = 0; i < galleryPhotos.length; i++) {
        var p = galleryPhotos[i];
        html += '<img class="pj-r-reviews-photo"'
          + ' src="' + escapeHtml(p.thumb) + '"'
          + ' data-photo-src="' + escapeHtml(p.full) + '"'
          + ' data-photo-name="' + escapeHtml(p.name) + '"'
          + ' data-photo-body="' + escapeHtml(p.body) + '"'
          + ' alt="" loading="lazy">';
      }
      galleryEl.innerHTML = html;
      galleryEl.removeAttribute('hidden');
    }

    function renderReview(r) {
      var name = (r.reviewer && r.reviewer.displayName) ? r.reviewer.displayName : 'Cliente Proper';
      var ago = timeAgoPt(r.dateCreated);
      var body = (r.body || '').replace(/\s+/g, ' ').trim();
      var verified = !!(r.reviewer && r.reviewer.isVerified);
      var media = r.media || [];

      var verifiedBadge = verified
        ? '<span class="pj-r-review-verified" title="Compra verificada"><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="2.5 6.5 5 8.5 9.5 3.5"></polyline></svg>Verificado</span>'
        : '';

      var photosHtml = '';
      var photoCount = 0;
      for (var j = 0; j < media.length; j++) {
        var m = media[j];
        if (m.type !== 'image') continue;
        var thumbUrl = m.thumbnailUrl || m.largeUrl || m.fullSizeUrl;
        var fullUrl = m.largeUrl || m.fullSizeUrl || m.thumbnailUrl;
        if (!thumbUrl) continue;
        var attrs = 'src="' + escapeHtml(thumbUrl) + '"'
          + ' data-photo-src="' + escapeHtml(fullUrl) + '"'
          + ' data-photo-name="' + escapeHtml(name) + '"'
          + ' data-photo-body="' + escapeHtml(body) + '"';
        if (photoCount === 0) photosHtml += '<div class="pj-r-review-photos">';
        photosHtml += '<img class="pj-r-review-photo" ' + attrs + ' alt="" loading="lazy">';
        photoCount++;
      }
      if (photoCount > 0) photosHtml += '</div>';

      return '<li>'
        +   '<div class="pj-r-review-head">'
        +     '<strong class="pj-r-review-name">' + escapeHtml(name) + '</strong>'
        +     verifiedBadge
        +     '<span class="pj-r-review-time">' + escapeHtml(ago) + '</span>'
        +   '</div>'
        +   '<span class="pj-r-stars pj-r-stars--small" aria-hidden="true">' + okendoStarsFor(r.rating) + '</span>'
        +   '<p class="pj-r-review-text">' + escapeHtml(body) + '</p>'
        +   photosHtml
        + '</li>';
    }

    function renderFromCache() {
      var filtered = applyFilter(allReviews);
      if (filtered.length === 0) {
        if (nextUrl && !isFetching) {
          // ainda há mais páginas pra buscar — mostra loading e tenta puxar
          listEl.innerHTML = '<li class="pj-r-reviews-empty">Procurando avaliações…</li>';
        } else {
          listEl.innerHTML = '<li class="pj-r-reviews-empty">Nenhuma avaliação com esse filtro.</li>';
        }
        return;
      }
      var html = '';
      for (var i = 0; i < filtered.length; i++) html += renderReview(filtered[i]);
      listEl.innerHTML = html;
    }

    function renderSkeleton() {
      listEl.innerHTML = '<li class="pj-r-reviews-empty">Carregando avaliações…</li>';
    }

    function fetchAndAppend() {
      if (isFetching || !nextUrl) return Promise.resolve();
      isFetching = true;
      setMoreState('loading');
      return fetch(BASE + ensureV1(nextUrl)).then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      }).then(function (data) {
        var arr = (data && data.reviews) || [];
        for (var i = 0; i < arr.length; i++) allReviews.push(arr[i]);
        nextUrl = (data && data.nextUrl) ? data.nextUrl : null;
        renderFromCache();
        setMoreState(nextUrl ? 'idle' : 'done');
        isFetching = false;
        return null;
      }).catch(function (e) {
        if (window && window.console) console.warn('Okendo reviews fetch error', e);
        setMoreState('error');
        isFetching = false;
      });
    }

    /* Se o filter ativo retornar < 3 resultados, auto-puxa mais páginas
       até ter resultado satisfatório ou acabar paginação.
       Pra 'photos', tenta até 8 vezes pq fotos são raras. */
    function ensureMinResults(attemptsLeft) {
      if (attemptsLeft == null) attemptsLeft = currentFilter === 'photos' ? 8 : 3;
      if (attemptsLeft <= 0) return;
      var filtered = applyFilter(allReviews);
      if (filtered.length >= 5 || !nextUrl) return;
      fetchAndAppend().then(function () { ensureMinResults(attemptsLeft - 1); });
    }

    function setFilter(name) {
      currentFilter = name;
      Array.prototype.forEach.call(filterBtns, function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-rev-filter') === name);
      });
      // Reset completo — cada filter tem orderBy próprio, então precisa nova query.
      allReviews = [];
      nextUrl = buildInitialUrl(name);
      listEl.innerHTML = '<li class="pj-r-reviews-empty">Carregando…</li>';
      fetchAndAppend().then(function () { ensureMinResults(); });
    }

    Array.prototype.forEach.call(filterBtns, function (btn) {
      btn.addEventListener('click', function () {
        setFilter(btn.getAttribute('data-rev-filter'));
      });
    });

    renderSkeleton();
    fetchAndAppend();
    loadGalleryPhotos();
    if (moreBtn) moreBtn.addEventListener('click', fetchAndAppend);
  }

  /* ----- Wiring por tela do quiz -------------------------------------- */

  function wireDoresCards(state) {
    var step = stepEls[1];
    if (!step) return;
    var cards = step.querySelectorAll('.pj-card');
    Array.prototype.forEach.call(cards, function (card) {
      var id = card.dataset.id;
      if (state.answers.dores.indexOf(id) !== -1) card.classList.add('is-selected');
      card.addEventListener('click', function () {
        var idx = state.answers.dores.indexOf(id);
        if (idx === -1) state.answers.dores.push(id);
        else state.answers.dores.splice(idx, 1);
        card.classList.toggle('is-selected');
        saveState(state);
        refreshCta(state);
        // P1 engagement tracking — alimenta cohort analysis no PostHog
        _p1NoteCardClick(state.answers.dores.length);
      });
    });
  }

  /* Step 2 — Principal Dor (condicional): mostra apenas os cards das dores selecionadas no step 1 */
  function showPrincipalDorCards(state) {
    var step = stepEls[2];
    if (!step) return;
    var cards = step.querySelectorAll('.pj-card--principal');
    var dores = Array.isArray(state.answers.dores) ? state.answers.dores : [];
    Array.prototype.forEach.call(cards, function (card) {
      var id = card.dataset.id;
      var inDores = dores.indexOf(id) !== -1;
      card.classList.toggle('hidden', !inDores);
      card.classList.toggle('is-selected', inDores && id === state.answers.principalDor);
      card.setAttribute('aria-checked', (id === state.answers.principalDor) ? 'true' : 'false');
    });
  }

  function wirePrincipalDorOptions(state) {
    var step = stepEls[2];
    if (!step) return;
    var cards = step.querySelectorAll('.pj-card--principal');
    Array.prototype.forEach.call(cards, function (card) {
      var id = card.dataset.id;
      card.addEventListener('click', function () {
        if (card.classList.contains('hidden')) return;
        Array.prototype.forEach.call(cards, function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-checked', 'true');
        state.answers.principalDor = id;
        saveState(state);
        refreshCta(state);
        scheduleAdvance(state);
      });
    });
  }

  /* Step 3 — Nível Acne (condicional, só se principalDor === 'acne'): single-select 6 níveis */
  function wireAcneNivelOptions(state) {
    var step = stepEls[3];
    if (!step) return;
    var cards = step.querySelectorAll('.pj-card--acne');
    Array.prototype.forEach.call(cards, function (card) {
      var id = card.dataset.id;
      card.addEventListener('click', function () {
        Array.prototype.forEach.call(cards, function (c) {
          c.classList.remove('is-selected');
          c.setAttribute('aria-checked', 'false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-checked', 'true');
        state.answers.acneNivel = id;
        saveState(state);
        refreshCta(state);
        scheduleAdvance(state);
      });
    });
  }

  function wireFrequenciaOptions(state) {
    var step = stepEls[10];
    if (!step) return;
    var options = step.querySelectorAll('.pj-option');
    Array.prototype.forEach.call(options, function (opt) {
      var id = opt.dataset.id;
      if (state.answers.frequencia === id) opt.classList.add('is-selected');
      opt.addEventListener('click', function () {
        Array.prototype.forEach.call(options, function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        state.answers.frequencia = id;
        saveState(state);
        refreshCta(state);
        scheduleAdvance(state);
      });
    });
  }

  function wireTempoRotinaOptions(state) {
    var step = stepEls[8];
    if (!step) return;
    var options = step.querySelectorAll('.pj-option');
    Array.prototype.forEach.call(options, function (opt) {
      var id = opt.dataset.id;
      if (state.answers.tempoRotina === id) opt.classList.add('is-selected');
      opt.addEventListener('click', function () {
        Array.prototype.forEach.call(options, function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        state.answers.tempoRotina = id;
        saveState(state);
        refreshCta(state);
        scheduleAdvance(state);
      });
    });
  }

  function wireTomPeleSwatches(state) {
    var step = stepEls[6];
    if (!step) return;
    var swatches = step.querySelectorAll('.pj-tom');
    Array.prototype.forEach.call(swatches, function (sw) {
      var id = sw.dataset.id;
      if (state.answers.tomPele === id) sw.classList.add('is-selected');
      sw.addEventListener('click', function () {
        Array.prototype.forEach.call(swatches, function (s) { s.classList.remove('is-selected'); });
        sw.classList.add('is-selected');
        state.answers.tomPele = id;
        saveState(state);
        refreshCta(state);
        scheduleAdvance(state);
      });
    });
  }

  function wireTipoPeleOptions(state) {
    var step = stepEls[7];
    if (!step) return;
    var options = step.querySelectorAll('.pj-card');
    Array.prototype.forEach.call(options, function (opt) {
      var id = opt.dataset.id;
      if (state.answers.tipoPele === id) opt.classList.add('is-selected');
      opt.addEventListener('click', function () {
        Array.prototype.forEach.call(options, function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        state.answers.tipoPele = id;
        saveState(state);
        refreshCta(state);
        scheduleAdvance(state);
      });
    });
  }

  function wireAgeInput(state) {
    var step = stepEls[9];
    if (!step) return;
    var input = step.querySelector('.pj-age-input');
    var card = step.querySelector('.pj-age-card');
    var preview = step.querySelector('.pj-age-preview');
    var italic = step.querySelector('.pj-age-italic');
    if (!input || !card) return;
    input.value = state.answers.idade || '';

    function sync() {
      var cleaned = input.value.replace(/\D/g, '').slice(0, 2);
      input.value = cleaned;
      var n = parseInt(cleaned, 10);
      var valid = !isNaN(n) && n >= 10 && n <= 99;
      card.classList.toggle('has-value', cleaned.length > 0);
      card.classList.toggle('is-valid', valid);
      if (preview && italic) {
        if (valid) {
          preview.classList.remove('hidden');
          italic.textContent = cleaned;
        } else {
          preview.classList.add('hidden');
        }
      }
      state.answers.idade = cleaned;
      saveState(state);
      refreshCta(state);
    }

    sync();
    input.addEventListener('input', sync);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !ctaBtn.disabled) { e.preventDefault(); ctaBtn.click(); }
    });
  }

  function wireNameInput(state) {
    var step = stepEls[4];
    if (!step) return;
    var input = step.querySelector('.pj-name-input');
    var card = step.querySelector('.pj-name-card');
    var preview = step.querySelector('.pj-name-preview');
    var italic = step.querySelector('.pj-name-italic');
    var greetingName = step.querySelector('.pj-greeting-name');
    if (!input || !card || !preview || !italic) return;
    input.value = state.answers.nome || '';

    function sync() {
      var v = input.value.trim();
      var valid = v.length >= 2;
      card.classList.toggle('is-valid', valid);
      if (valid) {
        preview.classList.remove('hidden');
        italic.textContent = cap(v);
      } else {
        preview.classList.add('hidden');
      }
      // Atualiza o saudar do título: "Deixa a gente te conhecer melhor[, Nome] 🤝"
      if (greetingName) {
        greetingName.textContent = valid ? ', ' + cap(v) : '';
      }
      state.answers.nome = input.value;
      saveState(state);
      refreshCta(state);
    }

    sync();
    input.addEventListener('input', sync);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !ctaBtn.disabled) { e.preventDefault(); ctaBtn.click(); }
    });
  }

  function wireAdSlider() {
    var step = stepEls[5];
    if (!step) return;
    var slider = step.querySelector('.pj-ad-slider');
    if (!slider) return;
    var cards = slider.querySelectorAll('.pj-ad-card');
    if (!cards.length) return;
    var prev = step.querySelector('.pj-ad-arrow--prev');
    var next = step.querySelector('.pj-ad-arrow--next');
    var dots = step.querySelectorAll('.pj-ad-dot');

    function colWidth() {
      var first = cards[0];
      return first ? (first.offsetWidth + 12) : (slider.clientWidth * 0.8);
    }
    function activeCol() {
      var col = Math.round(slider.scrollLeft / colWidth());
      if (col < 0) col = 0;
      if (dots.length && col > dots.length - 1) col = dots.length - 1;
      return col;
    }
    function updateStates() {
      var atStart = slider.scrollLeft <= 4;
      var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 4;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      var col = activeCol();
      Array.prototype.forEach.call(dots, function (dot, i) {
        dot.classList.toggle('is-active', i === col);
      });
    }
    if (prev) prev.addEventListener('click', function () {
      slider.scrollBy({ left: -colWidth(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      slider.scrollBy({ left: colWidth(), behavior: 'smooth' });
    });
    Array.prototype.forEach.call(dots, function (dot, i) {
      dot.addEventListener('click', function () {
        slider.scrollTo({ left: i * colWidth(), behavior: 'smooth' });
      });
    });
    var scrollTimer;
    slider.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateStates, 60);
    }, { passive: true });
    window.addEventListener('resize', updateStates);
    setTimeout(updateStates, 50);
  }

  function wireContactInputs(state) {
    var step = stepEls[12];
    if (!step) return;
    var emailField = step.querySelector('[data-field="email"]');
    var emailInput = emailField ? emailField.querySelector('.pj-input') : null;
    var phoneField = step.querySelector('[data-field="whatsapp"]');
    var phoneInput = phoneField ? phoneField.querySelector('.pj-input') : null;
    if (!emailInput || !phoneInput) return;

    emailInput.value = state.answers.email || '';
    phoneInput.value = state.answers.whatsapp ? formatPhone(state.answers.whatsapp) : '';

    function syncEmail() {
      state.answers.email = emailInput.value.trim();
      emailField.classList.toggle('is-valid', isValidEmail(state.answers.email));
      saveState(state);
      refreshCta(state);
    }
    function syncPhone() {
      var formatted = formatPhone(phoneInput.value);
      phoneInput.value = formatted;
      state.answers.whatsapp = formatted;
      phoneField.classList.toggle('is-valid', isValidPhone(formatted));
      saveState(state);
      refreshCta(state);
    }

    syncEmail();
    syncPhone();

    emailInput.addEventListener('input', syncEmail);
    emailInput.addEventListener('focus', function () { emailField.classList.add('is-focused'); });
    emailInput.addEventListener('blur', function () { emailField.classList.remove('is-focused'); });
    phoneInput.addEventListener('input', syncPhone);
    phoneInput.addEventListener('focus', function () { phoneField.classList.add('is-focused'); });
    phoneInput.addEventListener('blur', function () { phoneField.classList.remove('is-focused'); });
    phoneInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !ctaBtn.disabled) { e.preventDefault(); ctaBtn.click(); }
    });
  }

  /* ----- Init ---------------------------------------------------------- */

  // Helper pra deferir trabalho non-critical pra idle time do main thread.
  // Reduz TBT (Total Blocking Time) do Lighthouse: cada wire function vira
  // task isolada que o browser executa entre frames de paint/scroll, sem
  // bloquear o user de ver conteúdo. Fallback setTimeout pra browsers sem
  // requestIdleCallback (Safari < 17 e alguns mobile).
  function idle(fn, fallbackDelay) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: 2000 });
    } else {
      setTimeout(fn, fallbackDelay || 50);
    }
  }

  function init() {
    root = document.getElementById('pj-quiz');
    if (!root) return;
    quizEl = root.querySelector('.pj-quiz-mode');
    resultEl = root.querySelector('.pj-result');
    progressFill = root.querySelector('.pj-progress-fill');
    progressText = root.querySelector('.pj-progress-percent');
    ctaBtn = root.querySelector('.pj-cta');
    ctaLabel = root.querySelector('.pj-cta-label');
    prevBtn = root.querySelector('.pj-prev');
    for (var n = 1; n <= STEP_COUNT; n++) {
      stepEls[n] = root.querySelector('.pj-step[data-step="' + n + '"]');
    }

    var state = loadState();
    if (!state) state = makeInitialState();

    // Detecta se está numa result page comparando o pathname atual com qualquer
    // entry do RESULT_PAGE_BY_DOR (legacy /pages/diagnostic-result + as novas
    // pages opacas por dor). Fallback de query string ?completed=true pra
    // compat com bookmarks/UTMs antigos.
    var currentPath = window.location.pathname;
    var isResultPath = false;
    for (var dorKey in RESULT_PAGE_BY_DOR) {
      if (RESULT_PAGE_BY_DOR.hasOwnProperty(dorKey) &&
          currentPath.indexOf(RESULT_PAGE_BY_DOR[dorKey]) !== -1) {
        isResultPath = true;
        break;
      }
    }
    // Detecção também pelo template (defesa em profundidade — se o user criar
    // mais pages no futuro com template_suffix=diagnostic-result mas sem ter
    // entry no mapa, ainda funciona como result page).
    if (!isResultPath && document.body && document.body.className) {
      isResultPath = document.body.className.indexOf('diagnostic-result') !== -1;
    }
    var params = new URLSearchParams(window.location.search);
    var isCompletedView = isResultPath || params.get('completed') === 'true';

    // Safety lock: se redirecionamos nos últimos 3s, não redireciona de novo.
    // Mata qualquer loop independente da causa raiz (state corrompido, URL não
    // matching, etc). Usa sessionStorage pra escopo de tab (limpa ao fechar).
    var REDIRECT_LOCK_KEY = 'pj_redirect_lock';
    var REDIRECT_LOCK_MS = 3000;
    function recentlyRedirected() {
      try {
        var raw = sessionStorage.getItem(REDIRECT_LOCK_KEY);
        if (!raw) return false;
        var ts = parseInt(raw, 10);
        if (isNaN(ts)) return false;
        return (Date.now() - ts) < REDIRECT_LOCK_MS;
      } catch (_) { return false; }
    }
    function markRedirect() {
      try { sessionStorage.setItem(REDIRECT_LOCK_KEY, String(Date.now())); } catch (_) {}
    }

    // Se user JÁ completou (state.completedAt setado) e tá voltando no quiz body
    // (NÃO em result path), redireciona direto pra result page dele em vez de
    // forçá-lo a re-ver step 12 (Contato). Detectado via session replay: users
    // recorrentes caíam no form de email/whatsapp em vez do resultado.
    // resetState() chamado pelo botão "Refazer o Quiz" limpa completedAt antes
    // do redirect — então essa lógica não trava o flow de quem quer refazer.
    if (!isResultPath && state.completedAt && state.answers && state.answers.principalDor && !recentlyRedirected()) {
      markRedirect();
      var resumeUrl = RESULT_PAGE_BY_DOR[state.answers.principalDor] || DEFAULT_RESULT_PAGE;
      window.location.replace(resumeUrl);
      return;
    }

    if (isCompletedView) {
      // Sem state.completedAt no result path → manda pro quiz pra completar
      if (isResultPath && !state.completedAt && !recentlyRedirected()) {
        markRedirect();
        window.location.href = '/pages/diagnostic';
        return;
      }
      if (state.completedAt) {
        // Cache da dor pra wire functions (event tracking inclui kit_code)
        _resultDor = state.answers.principalDor || '';
        // CRÍTICO — above-the-fold, precisa rodar antes do user interagir:
        // render do conteúdo + CTA principal + kit switcher + sticky.
        // ORDEM IMPORTA: buildGalleryThumbs PRECISA rodar antes de
        // wireKitAlternatives — o filtro de variant (updateGalleryForVariant)
        // chamado no init de wireKitAlternatives filtra os thumbs por
        // data-variant-set, mas se os thumbs ainda não foram criados, nenhum
        // filtro é aplicado e todos os thumbs (de todos os kits) aparecem.
        renderResultPage(state);
        buildGalleryThumbs();
        wireGalleryArrows();
        wireKitAlternatives();
        wireCtaCartAdd();
        wireSubscriptionToggle();
        wireFrequencyToggle();
        wireStickyCta();
        wireSubscriptionDetailsModal();

        // DEFERIDO — below-the-fold ou só ativa em interação. Roda em idle pra
        // não bloquear o paint inicial (reduz TBT do Lighthouse de ~2000ms).
        idle(function () { enhanceRoutineDescriptions(); });
        idle(function () { wireRoutineComposition(); wireRoutineAccordion(); });
        idle(function () { wireVideoTestimonials(); wireVideoDots(); });
        idle(function () { wireSliderArrows(); wireResultAdDots(); });
        idle(function () { wireModalCloseDelegation(); wireOkendoPhotoLightbox(); });
        idle(function () { wireScrollAnchors(); wireIaMore(); wireResultRestart(); });
        idle(function () { inflateOkendoCount(); wireOkendoReviews(); }, 500);
        return;
      }
      var url = new URL(window.location.href);
      url.searchParams.delete('completed');
      window.history.replaceState({}, '', url.toString());
    }

    // Setup do mapa de wiring. Cada step só é wirado quando goToStep é
    // chamado pra ele (on-demand). Elimina o trabalho desnecessário de
    // pre-wirar 12 steps no init que virava long tasks no Lighthouse.
    _stepWirers = {
      1:  function () { wireDoresCards(state); },
      2:  function () { wirePrincipalDorOptions(state); },
      3:  function () { wireAcneNivelOptions(state); },
      4:  function () { wireNameInput(state); },
      5:  function () { wireAdSlider(); },
      6:  function () { wireTomPeleSwatches(state); },
      7:  function () { wireTipoPeleOptions(state); },
      8:  function () { wireTempoRotinaOptions(state); },
      9:  function () { wireAgeInput(state); },
      10: function () { wireFrequenciaOptions(state); },
      11: function () { /* interstitial Forbes - sem wiring específico */ },
      12: function () { wireContactInputs(state); }
    };

    ctaBtn.addEventListener('click', function () {
      if (ctaBtn.disabled) return;
      // GA4: usuário respondeu o step atual e avançou. Diferente do step_view
      // (que dispara em qualquer entrada, inclusive back). Esse só dispara em
      // forward — é o que importa pro funil de conversão.
      pjTrack('step_answered', { step: state.step, dor_principal: state.answers.principalDor || '' });
      goToStep(state, state.step + 1);
    });
    prevBtn.addEventListener('click', function () {
      // GA4: usuário voltou — útil pra mapear pontos de fricção/dúvida.
      pjTrack('back', { step: state.step });
      goToStep(state, state.step - 1);
    });

    var landing = state.step;
    if (typeof landing !== 'number' || landing < 1) landing = 1;
    if (landing > STEP_COUNT) landing = STEP_COUNT;

    // GA4: usuário aterrissou no /pages/diagnostic. Diferente do GA4 page_view
    // automático — esse só dispara quando o quiz foi inicializado com sucesso
    // (filtra crawlers, prerender, etc). É o "topo de funil" do quiz.
    pjTrack('landing', { step: landing, has_state: state.startedAt ? 1 : 0 });

    // goToStep vai chamar wireStepOnce(landing) automaticamente.
    goToStep(state, landing);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
